// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-28T16:32:57.941Z
// Property: The Summit at Rock Hill (ID: 6767906449164261)
// Collections: 26 amenities, 6 floorplans (live), 25 photos, 117 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449164261",
  "property_external_id": "5449562",
  "property_zillow_url": "https://www.zillow.com/homedetails/1817-Paces-River-Ave-Rock-Hill-SC-29732/2128768172_zpid/",
  "property_apartments_url": "https://www.apartments.com/the-summit-at-rock-hill-rock-hill-sc/63l7fzr",
  "property_google_business_url": "https://www.google.com/maps/place/The+Summit+at+Rock+Hill/data=!4m2!3m1!1s0x0:0x5b3c46f946866543?sa=X&ved=2ahUKEwijiMezzrySAxXKSTABHYMEJMYQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "26794657830",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-summit-at-rock-hill",
  "property_name": "The Summit at Rock Hill",
  "property_website_url": "https://www.thesummitatrockhill.com/",
  "property_domain": "https://www.thesummitatrockhill.com/",
  "property_address": "1817 Paces River Ave",
  "property_full_address": "1817 Paces River Ave, Rock Hill, SC 29732",
  "property_address_1": "1817 Paces River Ave",
  "property_address_2": null,
  "property_address_city": "Rock Hill",
  "property_address_state": "SC",
  "property_address_zip_full": "29732-1775",
  "property_address_zip": "29732",
  "property_address_country": "US",
  "property_address_county": "York County",
  "property_neighborhood_address": "Outlying York County",
  "property_address_latitude": "34.9821289",
  "property_address_longitude": "-80.9892743",
  "property_email": "pacesriver@rrliving.com",
  "property_phone": "(803) 877-6363",
  "property_call_tracking_phone": "803-471-4372",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Welcome to The Summit at Rock Hill where vibrant living meets ultimate convenience in Rock Hill, SC. With a stunning pool, modern fitness center, and exciting planned social activities, your ideal escape awaits. Enjoy 24-hour access, package service, and maintenance at your fingertips. Begin your next chapter—check our availability or schedule a tour today!</p>",
  "property_long_description": "<p>About The Summit at Rock Hill Welcome home to The Summit at Rock Hill! The Summit at Rock Hill is an apartment community located in York County and the 29732 ZIP Code. This area is served by the York 03 attendance zone.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-843c-70c2-8218-d7aa94e8bcb0.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and a fire pit area.",
    "public_id": "01a0f8cc-843c-70c2-8218-d7aa94e8bcb0",
    "storage_key": "property/6767906449164261/01a0f8cc-843c-70c2-8218-d7aa94e8bcb0.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "1989",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "87.08333333333333",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed (breed restrictions apply). Maximum of 2 pets per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://thesummitatrockhill.loftliving.com/login",
  "property_apply_now_url": "https://9192026.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e84da-5858-7244-aaba-1b43b3d7fd5f.webp",
  "property_primary_logo_media": {
    "alt_text": "The Summit at Rock Hill logo",
    "public_id": "019e84da-5858-7244-aaba-1b43b3d7fd5f",
    "storage_key": "property/6767906449164261/019e84da-5858-7244-aaba-1b43b3d7fd5f.webp",
    "width": 3072,
    "height": 1728
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd4-f250-767e-a7ae-25da4491c46e.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Summit at Rock Hill logo",
    "public_id": "019e1dd4-f250-767e-a7ae-25da4491c46e",
    "storage_key": "property/6767906449164261/019e1dd4-f250-767e-a7ae-25da4491c46e.webp",
    "width": 1920,
    "height": 885
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e8e86-f3eb-7074-bde9-d3c4998ede93.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Summit at Rock Hill logo",
    "public_id": "019e8e86-f3eb-7074-bde9-d3c4998ede93",
    "storage_key": "property/6767906449164261/019e8e86-f3eb-7074-bde9-d3c4998ede93.webp",
    "width": 1280,
    "height": 720
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e8e86-e86c-7508-a866-434cd65808a7.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-e86c-7508-a866-434cd65808a7",
    "storage_key": "property/6767906449164261/019e8e86-e86c-7508-a866-434cd65808a7.webp",
    "width": 1280,
    "height": 720
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000b2d",
  "property_secondary_color": "#bca48b",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#96999c",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "558 - 1261",
  "property_sqft_min": "558",
  "property_sqft_max": "1261",
  "property_price_range": "1109 - 1549",
  "property_price_min": "1109",
  "property_price_max": "1549",
  "property_available_units": 31,
  "property_facebook_url": "https://www.facebook.com/people/The-Summit-at-Rock-Hill-Apartments/61576598459912/",
  "property_instagram_url": "https://www.instagram.com/thesummitatrockhill/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJu-NC-FiPVogRQ2WGRvlGPFs",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/paces-river-apartment-homes-bh-management-rock-hill",
  "property_tiktok_url": "https://www.tiktok.com/@thesummitrockhill",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Summit at Rock Hill",
  "property_home_romance_title": "Embrace Your Dream Lifestyle in Our Charming Community",
  "property_home_amenities_blurb": "<p>Welcome to Summit at Rock Hill, your ideal apartment community nestled in the heart of Rock Hill, SC. With a variety of thoughtfully designed floor plans, our residences offer the perfect blend of comfort and style.</p>\n<p>At Summit at Rock Hill, you'll find an array of exceptional amenities designed to enhance your lifestyle. Dive into relaxation at our inviting pool or unwind in the soothing hot tub and spa. Our clubhouse is the perfect spot to socialize, while our outdoor grilling area and cabana make every gathering a memorable one. Families and outdoor enthusiasts will also enjoy our on-site playground, providing a fun and welcoming space for all ages.</p>\n<p>Enjoy the convenience of online services and package delivery, along with maintenance on-site for peace of mind. A trash pickup service right at your door ensures a hassle-free living experience. The community features an expansive courtyard, perfect for relaxing or enjoying planned social activities with your neighbors. Our fenced lot offers added security, while ample storage space ensures you’ll never run out of room.</p>",
  "property_home_floorplans_blurb": "<p>At Summit at Rock Hill in Rock Hill, SC, your perfect home is conveniently nestled among vibrant local favorites and hidden gems. From charming cafes to lush parks, our neighborhood invites you to immerse yourself in the community's lively spirit.</p>\n<p>Find your new home today—browse our availability or schedule a tour to visit our welcoming community. Experience the best of apartment living at The Summit at Rock Hill!</p>",
  "property_home_gallery_blurb": "At The Summit at Rock Hill, your ideal home awaits in spacious one, two, and three-bedroom floor plans. Indulge in modern amenities like a state-of-the-art fitness center, inviting poolside grilling area, and lighted tennis courts. Picture yourself enjoying relaxed evenings on your private patio or cozying up by a wood-burning fireplace!",
  "property_home_neighborhood_blurb": "At Paces River in Rock Hill, SC, your perfect home is conveniently nestled among vibrant local favorites and hidden gems. From charming cafes to lush parks, our neighborhood invites you to immerse yourself in the community's lively spirit. Experience the best of life just beyond your doorstep!",
  "property_home_reviews_blurb": "Nestled in the heart of Rock Hill, The Summit at Rock Hill offers a serene escape with luxurious amenities. Residents rave about the friendly staff and beautifully maintained grounds, saying, \"Our building is quiet with good neighbors.\" Experience unparalleled comfort and convenience—your serene sanctuary awaits!",
  "property_neighborhood_blurb": "<p>At Summit at Rock Hill in Rock Hill, SC, your perfect home is conveniently nestled among vibrant local favorites and hidden gems. From charming cafes to lush parks, our neighborhood invites you to immerse yourself in the community's lively spirit.</p>\n<p>Find your new home today—browse our availability or schedule a tour to visit our welcoming community. Experience the best of apartment living at The Summit at Rock Hill!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At The Summit at Rock Hill in Rock Hill, SC, community life thrives with our vibrant poolside cabana, invigorating fitness center, and relaxing hot tub. Enjoy convenient online services, planned social activities, and 24-hour access to a host of amenities designed to enrich your lifestyle. Your perfect home awaits—join us today!</p>",
  "property_applynow_blurb": "At Paces River in Rock Hill, SC, your ideal lifestyle awaits. With a sparkling pool, a state-of-the-art fitness center, and a vibrant clubhouse, our community offers everything for relaxation and recreation. Enjoy 24-hour access, social activities, and convenient amenities just steps from campus. Secure your new home and lease online today!",
  "property_contactus_blurb": "At Paces River in Rock Hill, SC, our diverse floor plans cater to your unique lifestyle. Whether you seek cozy studios or spacious three-bedroom homes, we’ve got the perfect fit for you. Have questions? Our friendly leasing team is ready to help—reach out today and start your new journey!",
  "property_faqs_blurb": "At Paces River in Rock Hill, SC, we understand that your questions matter. Our FAQs page is designed to address your inquiries about our vibrant community and diverse floor plans. Dive in to uncover valuable insights and find the perfect fit for your lifestyle at Paces River!",
  "property_floorplans_blurb": "<p>At The Summit at Rock Hill in Rock Hill, SC, your ideal living space awaits! With a variety of thoughtfully designed floor plans, each detail reflects comfort and style. Browse our available apartment homes to find the perfect layout that suits your lifestyle and enjoy the vibrant community around you!</p>",
  "property_gallery_blurb": "<p>At The Summit at Rock Hill in Rock Hill, SC, every detail is designed for your enjoyment, from our inviting pool and rejuvenating hot tub to the vibrant clubhouse and playground. Picture yourself living here, surrounded by conveniences like a 24-hour fitness center, online services, and community events—where comfort meets connection.</p>",
  "property_interactivemap_blurb": "At Paces River in Rock Hill, SC, your next chapter awaits! With enticing amenities like a refreshing pool, a state-of-the-art fitness center, and a vibrant playground, our community offers everything you need. Use our interactive community map to explore available apartments and find your perfect haven today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Paces River in Rock Hill, SC, friendship flourishes alongside comfort. With our diverse floor plans tailored to fit every lifestyle, your perfect home awaits. Share the joy of living in our vibrant community—refer a friend today, and let's create unforgettable memories together in a place you'll both love!",
  "property_residentaccess_blurb": "Welcome to Paces River in Rock Hill, SC, where convenience meets community. Access your resident portal to streamline your living experience—pay rent effortlessly, schedule maintenance with a click, and enjoy all that our vibrant community has to offer. Your new home awaits; let us enhance your lifestyle today!",
  "property_reviews_blurb": "Experience the charm of The Summit at Rock Hill, where spacious floor plans meet serene surroundings. Residents rave about the \"friendly staff\" and \"responsive maintenance,\" all nestled close to shopping and nature. With a blend of comfort and convenience, it's the perfect place to create your next joyful memories!",
  "property_created_at": "1747424472236",
  "property_scheduletour_blurb": "At Paces River in Rock Hill, SC, our diverse floor plans cater to every lifestyle, ensuring a perfect fit for you. Immerse yourself in a thriving community where happiness thrives. Curious? Hear firsthand experiences from our residents and envision your new home today by scheduling a tour!",
  "property_thankyou_blurb": "Thank you for reaching out to Paces River in beautiful Rock Hill, SC! Your interest in our vibrant community is appreciated. From spacious layouts to thoughtful amenities, our floor plans cater to every lifestyle. Expect to hear from our team soon to help you find your perfect home!",
  "property_virtualtours_blurb": "<p>Step into The Summit at Rock Hill, where serene living meets modern design in Rock Hill, SC. Our diverse floor plans cater to every lifestyle, ensuring you find your perfect fit. Experience the beauty and comfort of our community—take a virtual tour today to envision your new home in vibrant style!</p>",
  "property_copyright": "2025 All Rights Reserved. Paces River",
  "property_seo_title_home": "The Summit at Rock Hill | Apartments for Rent in Rock Hill",
  "property_seo_description_home": "Experience the convenience & comfort at The Summit at Rock Hill in Rock Hill, SC. We offer 1, 2, & 3-bedroom pet-friendly apartments to fit your every need.",
  "property_seo_title_floorplans": "Floor Plans | 1, 2, & 3 Bedroom Rock Hill Apartments",
  "property_seo_description_floorplans": "The Summit at Rock Hill offers 1, 2, & 3-bedroom layouts with luxurious comfort in Rock Hill, SC. Browse our apartments for rent now!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments in Rock Hill, SC",
  "property_seo_description_amenities": "The Summit at Rock Hill is an apartment community with modern amenities and apartments, all conveniently located in Rock Hill, SC.",
  "property_seo_title_gallery": "Gallery | Rock Hill Apartments",
  "property_seo_description_gallery": "View your new home in Rock Hill, SC through our photos - explore apartment interiors, amenities, & more. Take a look at The Summit at Rock Hill's photos now!",
  "property_seo_title_virtualtours": "Virtual Tour | Rock Hill Apartments",
  "property_seo_description_virtualtours": "Discover your new home at The Summit at Rock Hill! Take a virtual tour of our floor plans, amenities, & more. Start your tour now in Rock Hill, SC!",
  "property_seo_title_interactivemap": "Interactive Leasing | The Summit at Rock Hill ",
  "property_seo_description_interactivemap": "Our extensive floor plans cater to every lifestyle, inviting you to envision your perfect home. Your ideal living space is just a click away!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near York County Airport",
  "property_seo_description_neighborhood": "The Summit at Rock Hill is located in Rock Hill, SC, with unique neighborhood perks. Explore the Rock Hill area now - come in for a tour of our apartments!",
  "property_seo_title_contact": "Contact Us | 1, 2, & 3 Bedroom Rock Hill Apartments for Rent",
  "property_seo_description_contact": "Have questions about applying or want to schedule a tour? Our amazing leasing team is on standby ready to help! Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Rock Hill, SC",
  "property_seo_description_faqs": "Uncover the lifestyle you've been searching for at Paces River in Rock Hill, SC. With an array of enticing amenities—from a refreshing swimming pool to a vibrant clubhouse and fitness center—every day here feels like a retreat. Enjoy stress-free living with convenient features like door-to-door trash pickup, 24-hour access, and online services. Got questions? Our FAQs page has all the insights you need about our community. Join us and dive into a life of comfort and convenience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rock Hill, SC",
  "property_seo_description_reviews": "\"Experience the vibrant lifestyle at Paces River in Rock Hill, SC, where our residents enjoy top-notch amenities like a refreshing pool, fitness center, and cozy clubhouse. Join a community that values connection with planned social activities and family-friendly spaces like our playground. Our commitment to convenience shines through with 24-hour access, package service, and door-to-door trash pickup. Don’t just take our word for it—see what our residents have to say about their life at Paces River!\"",
  "property_seo_title_applynow": "Apply Now | 1, 2, & 3 Bedroom Apartments in Rock Hill, SC",
  "property_seo_description_applynow": "Ready to make The Summit at Rock Hill your new home? Apply online for our 1, 2, or 3-bedroom apartments for rent in Rock Hill, SC. Complete the application today!",
  "property_seo_title_residentaccess": "Resident Access | Rock Hill Apartments for Rent",
  "property_seo_description_residentaccess": "With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service and pay your rent online. Log in to get started.",
  "property_seo_title_referafriend": "Refer a Friend | Apartments in Rock Hill, SC",
  "property_seo_description_referafriend": "Refer a friend to The Summit at Rock Hille and both of you can enjoy fantastic perks. Spread the word!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments in Rock Hill, SC",
  "property_seo_description_scheduletour": "Ready to explore The Summit at Rock Hill firsthand? Book a tour and uncover our amenities and 1, 2, & 3-bedroom apartments in Rock Hill, SC!",
  "property_seo_title_privacy": "Privacy Policy | The Summit at Rock Hill",
  "property_seo_description_privacy": "Our comprehensive privacy policy outlines how we protect your personal information while you enjoy our vibrant community. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Summit at Rock Hill",
  "property_seo_description_accessibility": "Our Accessibility Statement reflects our commitment to digital inclusion, ensuring that all residents can easily navigate and engage with our community online.",
  "property_seo_title_sitemap": "Sitemap | The Summit at Rock Hill ",
  "property_seo_description_sitemap": "Our sitemap guides you through our harmonious community, showcasing amenities, floor plans, and all the essentials for your next chapter. ",
  "property_seo_title_thankyou": "Thank You | Apartments for Rent in Rock Hill, SC",
  "property_seo_description_thankyou": "Thank you for your interest in The Summit at Rock Hill. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pet Policy | Apartments in Rock Hill, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793205160841",
  "amenities": [
    {
      "id": "custom_653b0556-839b-4de6-8e5f-6bdc517e4fb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c069f290-abee-471d-a271-ed1eecea1669",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Playground Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50a190e6-c796-4738-9156-5488a6db7f66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Grilling Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24a393dc-7f1b-489e-8085-82733719ea9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Preferred Employer Program (Black and Decker, Northern Tool, Pepsi Bottle Company, Frito Lay, West Marine, and PFG Customized Distribution)",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_11ac16ce-7bdd-4b6f-9789-0b383321b356",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d2113877-16d2-4cdc-8684-ea8d058ed07b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Nest Thermostats & USB Outlets*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_638700d5-d0b8-4a72-9713-f7205c875650",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9c78309-d117-4283-9bf8-2f159314d283",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ddb47e6b-79c5-43ea-8765-6c264d87b2a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios or Balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b87b30b-4565-4c96-b134-7f3748b90431",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Brushed Nickel Finishes & Light Fixture",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_868910cd-2651-461e-b3eb-c0be9f4ac62f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Flooring*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33507e25-ca30-4c89-b4fd-8cf0f54e707f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Microwaves*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3854010c-0813-48c3-8db1-ecdb92a21a4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_028fbfbb-cec4-4e19-9ad6-2ae9ea639b46",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b282741f-6881-4de8-b950-0460ce9f6258",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size Washer & Dryer Connections*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_285ef205-07a3-4b8e-8136-d7a80831f23e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Burning Fireplaces*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7b3d32c-ab84-429b-ab51-1e0ac3aac322",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Pantries*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_56dacf15-2e9f-471c-a304-54280ed7c465",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c1dd8622-daed-4c69-8b9e-a6841651d37b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park with Agility Course",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8977b3de-fac8-4d3a-a35a-583e8eb9f706",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1418b54-92db-4809-b3a3-f19cdf086946",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliance Package*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4c2565d-ab85-48f5-aef4-a43cac085b68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Black Finishings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84aa08ad-556b-43db-8aba-ae85975aad6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb910564-1066-4f9d-b67c-e268b95af53d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Chair Railing*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81e45efa-a899-4346-aace-750bb2b3b190",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/dryer In Unit*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ccf46d6-6d16-4695-b78f-c6fee57daeb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "external_id": "false",
      "title": "Faux Wood Blinds*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d2bf4287-cf32-4f25-932d-4b37c10d2987",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-872b-76de-b9a0-2f27e29f5bba.webp",
      "image_media": {
        "alt_text": "The Summit at Rock Hill monument sign with landscaping",
        "public_id": "01a0f8cc-872b-76de-b9a0-2f27e29f5bba",
        "storage_key": "property/6767906449164261/01a0f8cc-872b-76de-b9a0-2f27e29f5bba.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Welcome to The Summit at Rock Hill, where comfort and convenience meet in a beautifully landscaped community.",
      "link": "",
      "alt_text": "The Summit at Rock Hill monument sign with landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99506943-f96b-4cc5-8d89-eabf3a096c58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-843c-70c2-8218-d7aa94e8bcb0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a fire pit area.",
        "public_id": "01a0f8cc-843c-70c2-8218-d7aa94e8bcb0",
        "storage_key": "property/6767906449164261/01a0f8cc-843c-70c2-8218-d7aa94e8bcb0.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, perfect for relaxing on a sunny day. Lounge chairs and a cozy fire pit area are available for your enjoyment.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a fire pit area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce6b788e-17d5-48e1-aaec-5ae8c720e2e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-86df-70eb-92ff-9c7329cb81f8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a0f8cc-86df-70eb-92ff-9c7329cb81f8",
        "storage_key": "property/6767906449164261/01a0f8cc-86df-70eb-92ff-9c7329cb81f8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush greenery and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_307da1d1-f11c-444b-a2eb-e7f8ae873b13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-8712-7429-82e5-3d87df22500d.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a dining table, fireplace, and kitchenette.",
        "public_id": "01a0f8cc-8712-7429-82e5-3d87df22500d",
        "storage_key": "property/6767906449164261/01a0f8cc-8712-7429-82e5-3d87df22500d.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Gather in the beautifully appointed communal lounge, perfect for residents to relax, dine, or socialize. Features include a stylish dining table, cozy fireplace, and a convenient kitchenette.",
      "link": "",
      "alt_text": "Modern communal lounge area with a dining table, fireplace, and kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_935863a1-15e6-42b3-b6b5-530510468cdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-835e-70aa-9e8f-48d935732d45.webp",
      "image_media": {
        "alt_text": "Lounge area with seating and coffee bar overlooking a swimming pool",
        "public_id": "01a0f8cc-835e-70aa-9e8f-48d935732d45",
        "storage_key": "property/6767906449164261/01a0f8cc-835e-70aa-9e8f-48d935732d45.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Relax in our stylish lounge with a convenient coffee bar, perfect for unwinding or socializing, with beautiful views of the resort-style pool.",
      "link": "",
      "alt_text": "Lounge area with seating and coffee bar overlooking a swimming pool",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c7802d1f-43bb-4a87-8a13-c4de31ee6aba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-efee-7548-90c9-0767313ef2b1.webp",
      "image_media": {
        "alt_text": "Interior lounge area with view of the outdoor swimming pool.",
        "public_id": "01a0f8cc-efee-7548-90c9-0767313ef2b1",
        "storage_key": "property/6767906449164261/01a0f8cc-efee-7548-90c9-0767313ef2b1.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating and a direct view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Interior lounge area with view of the outdoor swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df8aeeb0-a82c-4e46-af75-3188507c288d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-85c8-728d-bb53-3336c2c8c3e4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
        "public_id": "01a0f8cc-85c8-728d-bb53-3336c2c8c3e4",
        "storage_key": "property/6767906449164261/01a0f8cc-85c8-728d-bb53-3336c2c8c3e4.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool. Enjoy the sunshine on comfortable lounge chairs and cool off under the refreshing blue umbrellas. A perfect oasis for our residents.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f6128c5-d748-457c-bd85-38bc0e4b01ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-879e-74bd-8bbf-ac35a0e00c8e.webp",
      "image_media": {
        "alt_text": "Exterior view of the multifamily property's main building entrance with landscaping.",
        "public_id": "01a0f8cc-879e-74bd-8bbf-ac35a0e00c8e",
        "storage_key": "property/6767906449164261/01a0f8cc-879e-74bd-8bbf-ac35a0e00c8e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "View of the main building entrance at the multifamily property, featuring modern architecture and lush landscaping.",
      "link": "",
      "alt_text": "Exterior view of the multifamily property's main building entrance with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5c48740-a4a6-407a-b2db-861e68955341",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-8771-73ed-82da-9882b0806478.webp",
      "image_media": {
        "alt_text": "Playground with swings, seesaw, and slide in front of apartment buildings.",
        "public_id": "01a0f8cc-8771-73ed-82da-9882b0806478",
        "storage_key": "property/6767906449164261/01a0f8cc-8771-73ed-82da-9882b0806478.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring swings, a seesaw, and a slide, all set against a backdrop of lush greenery and apartment homes.",
      "link": "",
      "alt_text": "Playground with swings, seesaw, and slide in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8436397-05f1-44cd-8764-33538caff3ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/01a0f8cc-8680-7333-bbaf-567ac0f9d3c1.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and a parking lot.",
        "public_id": "01a0f8cc-8680-7333-bbaf-567ac0f9d3c1",
        "storage_key": "property/6767906449164261/01a0f8cc-8680-7333-bbaf-567ac0f9d3c1.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Modern apartment buildings with well-maintained landscaping and ample parking, offering a comfortable living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e334eda-b8ce-465c-a131-2ef86631d5c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019f5c42-ee6f-7048-baf2-ce5481bd5ba9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and tables",
        "public_id": "019f5c42-ee6f-7048-baf2-ce5481bd5ba9",
        "storage_key": "property/6767906449164261/019f5c42-ee6f-7048-baf2-ce5481bd5ba9.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas for a perfect day in the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and tables",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d7d678e8-f84c-40f7-adff-a91162755092",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd4-f94d-755a-8988-391ddca41b95.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace, sofa, and glass coffee table.",
        "public_id": "019e1dd4-f94d-755a-8988-391ddca41b95",
        "storage_key": "property/6767906449164261/019e1dd4-f94d-755a-8988-391ddca41b95.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room featuring a modern fireplace, comfortable sofa, and elegant glass coffee table. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Cozy living room with a fireplace, sofa, and glass coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d846b087-b6ee-4bb1-ac22-01005ee85018",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd4-f95f-731e-9167-9da4040da1be.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a blue upholstered bed, bedside tables, and a large window.",
        "public_id": "019e1dd4-f95f-731e-9167-9da4040da1be",
        "storage_key": "property/6767906449164261/019e1dd4-f95f-731e-9167-9da4040da1be.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush blue bed and ample natural light from the large window.",
      "link": "",
      "alt_text": "Cozy bedroom with a blue upholstered bed, bedside tables, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6e599942-23c5-4586-9ef2-3bd069f06cb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e84da-510c-71ca-b62c-a5bd8ec9963e.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and microwave above an electric stove in a modern kitchen.",
        "public_id": "019e84da-510c-71ca-b62c-a5bd8ec9963e",
        "storage_key": "property/6767906449164261/019e84da-510c-71ca-b62c-a5bd8ec9963e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "This kitchen features stainless steel appliances, including a refrigerator, microwave, and electric stove, complemented by white cabinetry and granite countertops.",
      "link": "",
      "alt_text": "Stainless steel refrigerator and microwave above an electric stove in a modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41674098-bd16-4192-842b-c2331ab96b12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd4-f810-72ea-ab30-5c5c5905d4d7.webp",
      "image_media": {
        "alt_text": "Dining area with a marble table and four blue velvet chairs.",
        "public_id": "019e1dd4-f810-72ea-ab30-5c5c5905d4d7",
        "storage_key": "property/6767906449164261/019e1dd4-f810-72ea-ab30-5c5c5905d4d7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a marble-top table with a striking gold base, complemented by plush blue velvet chairs, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a marble table and four blue velvet chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15401f05-b099-4693-9eeb-1babd8cde29e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e84da-5490-72de-a7d7-21b3e1d46b32.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinetry.",
        "public_id": "019e84da-5490-72de-a7d7-21b3e1d46b32",
        "storage_key": "property/6767906449164261/019e84da-5490-72de-a7d7-21b3e1d46b32.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into a beautifully updated kitchen featuring sleek granite countertops, a full suite of stainless steel appliances, and crisp white cabinetry. Perfect for home chefs and everyday convenience.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86058f02-67c4-42b2-88c5-75d9a2768d7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd4-f94e-7548-bde4-73c289d26af6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "019e1dd4-f94e-7548-bde4-73c289d26af6",
        "storage_key": "property/6767906449164261/019e1dd4-f94e-7548-bde4-73c289d26af6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "View of a contemporary kitchen featuring stainless steel appliances, including a refrigerator, microwave, and range, complemented by sleek white cabinets and granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7cac5417-b2db-4ec2-9dca-7942b04d54c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-5500-721c-a209-851cf39d99f0.webp",
      "image_media": {
        "alt_text": "Bedroom with daybed, desk, and closet.",
        "public_id": "019e1dd5-5500-721c-a209-851cf39d99f0",
        "storage_key": "property/6767906449164261/019e1dd5-5500-721c-a209-851cf39d99f0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a daybed with plush pillows, a stylish desk with a mirror, and ample closet space, perfect for relaxation and productivity.",
      "link": "",
      "alt_text": "Bedroom with daybed, desk, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3e674a2-5762-4a62-8aec-3acb64b935dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019f5c42-f4b3-7609-b547-d5fafc60f38b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with blue lounge chairs, patio tables with blue umbrellas, and a green turf area with cornhole boards.",
        "public_id": "019f5c42-f4b3-7609-b547-d5fafc60f38b",
        "storage_key": "property/6767906449164261/019f5c42-f4b3-7609-b547-d5fafc60f38b.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax by our inviting swimming pool, complete with comfortable lounge seating and shaded patio areas. Enjoy lawn games like cornhole on the adjacent turf for a fun-filled afternoon in the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with blue lounge chairs, patio tables with blue umbrellas, and a green turf area with cornhole boards.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c601fe65-04b6-4664-b4e4-3c32eea4b18e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-15d8-777e-8121-8a46157bc9e4.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, floor lamp, console, and mirror.",
        "public_id": "019e1dd5-15d8-777e-8121-8a46157bc9e4",
        "storage_key": "property/6767906449164261/019e1dd5-15d8-777e-8121-8a46157bc9e4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a fireplace, stylish console table with decorative items, and a floor lamp, creating a warm and inviting atmosphere.",
      "link": "",
      "alt_text": "Living room with fireplace, floor lamp, console, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_804948d3-3985-4cc7-8466-57ae3ed61c9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd4-f9a7-7569-85b5-d1b028c010b1.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, blue accent chair, glass coffee table, and fireplace.",
        "public_id": "019e1dd4-f9a7-7569-85b5-d1b028c010b1",
        "storage_key": "property/6767906449164261/019e1dd4-f9a7-7569-85b5-d1b028c010b1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, featuring a cozy fireplace and elegant decor.",
      "link": "",
      "alt_text": "Modern living room with a gray sofa, blue accent chair, glass coffee table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13085a62-a5cd-4674-aa34-973618570bf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-3959-73b3-87d3-693223b3c8fa.webp",
      "image_media": {
        "alt_text": "Dressing area with a desk, chair, and closet doors. A bathroom is visible through an open doorway.",
        "public_id": "019e1dd5-3959-73b3-87d3-693223b3c8fa",
        "storage_key": "property/6767906449164261/019e1dd5-3959-73b3-87d3-693223b3c8fa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Create your personal oasis in this dressing area, complete with a vanity desk and ample closet space. The adjoining bathroom offers modern comfort.",
      "link": "",
      "alt_text": "Dressing area with a desk, chair, and closet doors. A bathroom is visible through an open doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac55ceb2-8a82-4af4-a5fc-1aea7f21d721",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-4d94-70db-98b8-f60b0a5b181f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, black faucet, and a bathtub with a shower.",
        "public_id": "019e1dd5-4d94-70db-98b8-f60b0a5b181f",
        "storage_key": "property/6767906449164261/019e1dd5-4d94-70db-98b8-f60b0a5b181f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek white vanity with a modern black faucet, and a pristine bathtub with an overhead shower, perfect for relaxing after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, black faucet, and a bathtub with a shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8a3588e8-210f-41d1-a255-b1f8747e0c36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-17c1-720b-92c8-a850e4cad407.webp",
      "image_media": {
        "alt_text": "Bedroom with a navy blue headboard, white comforter, and blue accent pillows. A console table with a mirror is visible.",
        "public_id": "019e1dd5-17c1-720b-92c8-a850e4cad407",
        "storage_key": "property/6767906449164261/019e1dd5-17c1-720b-92c8-a850e4cad407.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed with navy blue accents and a sleek console table with a round mirror, offering a stylish retreat.",
      "link": "",
      "alt_text": "Bedroom with a navy blue headboard, white comforter, and blue accent pillows. A console table with a mirror is visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_733b31b3-2e90-4708-bc9f-15cb91955c6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e84da-5494-74ed-8cad-e300e289af3a.webp",
      "image_media": {
        "alt_text": "Washer and dryer units with a shelf above.",
        "public_id": "019e84da-5494-74ed-8cad-e300e289af3a",
        "storage_key": "property/6767906449164261/019e84da-5494-74ed-8cad-e300e289af3a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "",
      "alt_text": "Washer and dryer units with a shelf above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_530ec9e1-c28d-4298-914a-476eed4c8670",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Grapevine - Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "829 Terrace Park #104, Rock Hill, SC 29730, USA",
      "poi_short_description": "Informal spot for coffee and pastries, plus beers, charcuterie and wines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-9e27-728d-9e85-03cd345c1550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-9e27-728d-9e85-03cd345c1550",
        "storage_key": "property/6767906449164261/019e1dd7-9e27-728d-9e85-03cd345c1550.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.grapevine.wine/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11078737473778064275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grapevine---riverwalk",
      "poi_latitude": "34.9833944",
      "poi_longitude": "-80.9724277",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-802-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bf8-76d1-85b4-54976255e477",
        "storage_key": "property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS45JuyFVogRk5tZ5AiVv5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_b0fcc8ed-356f-474d-a784-de8228edcfb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Blend Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "652 Herrons Ferry Road Suite 113, Rock Hill, SC 29730, USA",
      "poi_short_description": "Counter-serve eatery featuring wraps, bowls and salads plus customizable options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-6867-74cf-8544-07189ab42dc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-6867-74cf-8544-07189ab42dc4",
        "storage_key": "property/6767906449164261/019e1dd7-6867-74cf-8544-07189ab42dc4.webp",
        "width": 812,
        "height": 1280
      },
      "poi_business_url": "https://blendriverwalk.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=13389436288506486478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blend-riverwalk",
      "poi_latitude": "34.983101",
      "poi_longitude": "-80.9721834",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-324-3113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd67lS1qFVogRzl4nN13V0Lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ae2724ed-4c5c-4adb-91db-9ef8f6131d93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Richie's Italian Bistro at Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "819 Terrace Park Suite 103, Rock Hill, SC 29730, USA",
      "poi_short_description": "Casual eatery for New York-style pizza and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-5e23-754d-baa2-65c507dbc7ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-5e23-754d-baa2-65c507dbc7ce",
        "storage_key": "property/6767906449164261/019e1dd7-5e23-754d-baa2-65c507dbc7ce.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://richiesitalianbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14232435241377436117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richies-italian-bistro-at-riverwalk",
      "poi_latitude": "34.9831079",
      "poi_longitude": "-80.9726209",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-327-4992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm8smrb6FVogR1ZENA3LEg8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_0023e3a1-2b47-40e3-b200-e2bf8ea73472",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "The Pump House",
      "poi_type": "Restaurants",
      "poi_address": "575 Herrons Ferry Road, Rock Hill, SC 29730, USA",
      "poi_short_description": "Sophisticated, riverfront outpost featuring New American cuisine, craft cocktails & a rooftop bar.",
      "poi_long_description": "Sophisticated, riverfront outpost featuring New American cuisine, craft cocktails & a rooftop bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-54bf-73a5-9a81-d819a4ae78ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd5-54bf-73a5-9a81-d819a4ae78ff",
        "storage_key": "property/6767906449164261/019e1dd5-54bf-73a5-9a81-d819a4ae78ff.webp",
        "width": 600,
        "height": 449
      },
      "poi_business_url": "https://rockhillpumphouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16827820704898329489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pump-house",
      "poi_latitude": "34.9849014",
      "poi_longitude": "-80.9737537",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-329-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85Mg1e6FVogRkattA8ZtiOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_40a4a4b7-8034-467e-96a2-dd06b90976cb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Tony's Cantina Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "652 Herrons Ferry Road Suite 109, Rock Hill, SC 29730, USA",
      "poi_short_description": "Casual eatery serving Mexican eats and margaritas by the Catawba River, with patio dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-7f13-7607-8a02-f6c3cf643906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-7f13-7607-8a02-f6c3cf643906",
        "storage_key": "property/6767906449164261/019e1dd7-7f13-7607-8a02-f6c3cf643906.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rockhill.tonyscantina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10565302320553425726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tonys-cantina-mexican-grill",
      "poi_latitude": "34.9834222",
      "poi_longitude": "-80.9720519",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-328-8669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Qq2PrqFVogRPnsysXt-n5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f47992dd-03e7-47bf-ba7f-ecca24d6ba04",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Empire Pizza Rock Hill",
      "poi_type": "Restaurants",
      "poi_address": "The Original Empire, 1405 Riverchase Blvd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Casual, kid-friendly bar and grill offering a range of pizza options and Italian classics, plus burgers, wings, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-6996-7378-b857-b15cddb83e7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-6996-7378-b857-b15cddb83e7a",
        "storage_key": "property/6767906449164261/019e1dd7-6996-7378-b857-b15cddb83e7a.webp",
        "width": 719,
        "height": 1280
      },
      "poi_business_url": "http://www.empirepizzabar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13007475182841638868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "empire-pizza-rock-hill",
      "poi_latitude": "34.9771694",
      "poi_longitude": "-80.99104450000002",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 803-980-0522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_dlOXVePVogR1C_8IcPVg7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_0507768a-1554-4841-8189-033df5af7f86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Knowledge Perk Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "130 W White St, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-a662-708a-ae71-36c817fd3fa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-a662-708a-ae71-36c817fd3fa5",
        "storage_key": "property/6767906449164261/019e1dd7-a662-708a-ae71-36c817fd3fa5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://knowledgeperk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3388852991508843996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knowledge-perk-coffee-company",
      "poi_latitude": "34.9287296",
      "poi_longitude": "-81.0278601",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-327-7375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5YDEv-IVogR3I3nQtefBy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_roastery"
    },
    {
      "id": "custom_80b459d0-1e40-444f-9038-df134b149b81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Amélie's French Bakery & Café",
      "poi_type": "Restaurants",
      "poi_address": "157 E Main St, Rock Hill, SC 29730, USA",
      "poi_short_description": "This charming gathering place draws a crowd for its pastries, light fare & coffee drinks.",
      "poi_long_description": "This charming gathering place draws a crowd for its pastries, light fare & coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-6475-76de-a061-02a8ea5b23bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-6475-76de-a061-02a8ea5b23bb",
        "storage_key": "property/6767906449164261/019e1dd7-6475-76de-a061-02a8ea5b23bb.webp",
        "width": 800,
        "height": 1200
      },
      "poi_business_url": "http://www.ameliesfrenchbakery.com/?utm_source=local&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7743095968249824219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amlies-french-bakery--caf",
      "poi_latitude": "34.925179",
      "poi_longitude": "-81.0260237",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-403-9409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c00-7088-b0df-66990ee23f0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c00-7088-b0df-66990ee23f0c",
        "storage_key": "property/6767906449164261/019e1dd9-1c00-7088-b0df-66990ee23f0c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJISNW2VWIVogR20NKKcIAdWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_fdb65171-97a5-4142-b13f-d7dba5c90526",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "The Flipside Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "129 Caldwell St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Relaxed bistro with a cool vibe featuring a Southern-style menu, specialty cocktails & draft beer.",
      "poi_long_description": "Relaxed bistro with a cool vibe featuring a Southern-style menu, specialty cocktails & draft beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-7f79-7570-b3e9-31b498724043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-7f79-7570-b3e9-31b498724043",
        "storage_key": "property/6767906449164261/019e1dd7-7f79-7570-b3e9-31b498724043.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theflipsiderestaurant.com/flipside-restaurant",
      "poi_directions_map_url": "https://maps.google.com/?cid=2628468211407580798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-flipside-restaurant",
      "poi_latitude": "34.9259682",
      "poi_longitude": "-81.0255203",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-324-3547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUpuDlaIVogRfu5afOkxeiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d31ee985-8467-4af3-a9f9-5699b064e7e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Elk Ave Tavern",
      "poi_type": "Restaurants",
      "poi_address": "125 Elk Ave, Rock Hill, SC 29730, USA",
      "poi_short_description": "Casual bar with comfort-food offerings, including a popular chicken sandwich, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-6cf7-7571-9865-9f5c2ac185ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-6cf7-7571-9865-9f5c2ac185ae",
        "storage_key": "property/6767906449164261/019e1dd7-6cf7-7571-9865-9f5c2ac185ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=671077746886090880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-ave-tavern",
      "poi_latitude": "34.9247642",
      "poi_longitude": "-81.0275237",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bf8-76d1-85b4-54976255e477",
        "storage_key": "property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzznBgCJVogRgKDQv6clUAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_2983a8e6-6bcc-44d1-adc9-99ec0a96bc3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Legal Remedy Brewing",
      "poi_type": "Restaurants",
      "poi_address": "129 Oakland Ave Suite 120, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-68b3-7298-a7b9-520812d0e9fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-68b3-7298-a7b9-520812d0e9fc",
        "storage_key": "property/6767906449164261/019e1dd7-68b3-7298-a7b9-520812d0e9fc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://legalremedybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16799137136381721133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legal-remedy-brewing",
      "poi_latitude": "34.930423",
      "poi_longitude": "-81.02489179999999",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6XD_7o2JVogRLfoaSziGIuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_80a60967-3383-47ae-90dc-d0d27f50c7a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "The Journeyman Tavern",
      "poi_type": "Restaurants",
      "poi_address": "129 Oakland Ave Suite 110, Rock Hill, SC 29730, USA",
      "poi_short_description": "Irish pub, serving burgers and Reuben egg rolls, with friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-c3b9-741c-b739-d386f852116b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-c3b9-741c-b739-d386f852116b",
        "storage_key": "property/6767906449164261/019e1dd7-c3b9-741c-b739-d386f852116b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thejourneymantavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11928894005049614432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-journeyman-tavern",
      "poi_latitude": "34.930423",
      "poi_longitude": "-81.02489179999999",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-324-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bf8-76d1-85b4-54976255e477",
        "storage_key": "property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_wXBDgOJVogRYOBERuXxi6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "irish_pub"
    },
    {
      "id": "custom_34c09112-e34d-4de0-b68e-e7643edbb8ed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Island Grill & Pub",
      "poi_type": "Restaurants",
      "poi_address": "465 S Herlong Ave, Rock Hill, SC 29732, USA",
      "poi_short_description": "Comfortable restaurant serving Caribbean cuisine, including popular Jamaican dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-999d-727c-b45f-3cd4ae826e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-999d-727c-b45f-3cd4ae826e89",
        "storage_key": "property/6767906449164261/019e1dd7-999d-727c-b45f-3cd4ae826e89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theislandgrillpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15926774042781677599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "island-grill--pub",
      "poi_latitude": "34.9541535",
      "poi_longitude": "-81.0583454",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-323-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5yfKjbqJVogRH_jptZtEB90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "custom_04e45d75-a1cf-4238-9b21-5f3770247107",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Common Market Rock Hill",
      "poi_type": "Restaurants",
      "poi_address": "161 W Main St, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-91c9-755c-ad96-cf4499250952.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-91c9-755c-ad96-cf4499250952",
        "storage_key": "property/6767906449164261/019e1dd7-91c9-755c-ad96-cf4499250952.webp",
        "width": 1280,
        "height": 812
      },
      "poi_business_url": "https://commonmarketisgood.com/rock-hill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15480103699041720803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "common-market-rock-hill",
      "poi_latitude": "34.9276143",
      "poi_longitude": "-81.0305223",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-329-6311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJndw4s_KJVogR45mXE0xg1NY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0fbd56f4-7d33-4990-916f-154ae1df8822",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Kounter",
      "poi_type": "Restaurants",
      "poi_address": "135 E Main St Suite 101, Rock Hill, SC 29730, USA",
      "poi_short_description": "Casual-posh eatery slinging gourmet grub cocktails and beer including staples and creative twists, along with brunch and lunch offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-a942-716c-b419-bdad693a30f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-a942-716c-b419-bdad693a30f0",
        "storage_key": "property/6767906449164261/019e1dd7-a942-716c-b419-bdad693a30f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kounterdining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6457816396428519515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kounter",
      "poi_latitude": "34.9255673",
      "poi_longitude": "-81.0267303",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-328-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUCMBbyJVogRW6jQLczFnlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_27769502-cbd9-47ba-a607-e23e8a7076aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1225 Cherry Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Neighborhood chain outlet supplying groceries, produce, and household goods, plus a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-b476-719a-8bdf-750abf6d2821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-b476-719a-8bdf-750abf6d2821",
        "storage_key": "property/6767906449164261/019e1dd7-b476-719a-8bdf-750abf6d2821.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.walmart.com/store/6962-rock-hill-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9431587892311423965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "34.9527231",
      "poi_longitude": "-81.0172992",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-324-1245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c46-76db-a45c-351d5865c0b2",
        "storage_key": "property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0yJjjcaIVogR3fsYpTe744I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a45f65dd-8182-4d57-a546-ff29379425b4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Publix Super Market at Cherry Road Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "2186 Cherry Rd Ste 101, Rock Hill, SC 29732, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-d918-73dd-b12f-7e4b2c865f37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-d918-73dd-b12f-7e4b2c865f37",
        "storage_key": "property/6767906449164261/019e1dd8-d918-73dd-b12f-7e4b2c865f37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1485&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=5352496145394125769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-cherry-road-crossing",
      "poi_latitude": "34.9648199",
      "poi_longitude": "-80.99684189999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-366-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c46-76db-a45c-351d5865c0b2",
        "storage_key": "property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHRYclK2IVogRyUvdr-LiR0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_53d72047-cecb-4605-8961-b2a42269e0f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1918 Mt Gallant Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Grocery chain with a bakery, for staples like produce and meats, plus prepared foods, an in-store deli and a hot bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-aa6c-7509-9e16-caf9e2d43ad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-aa6c-7509-9e16-caf9e2d43ad4",
        "storage_key": "property/6767906449164261/019e1dd7-aa6c-7509-9e16-caf9e2d43ad4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/sc/rock-hill/1918-mt.-gallant-rd.?y_source=1_NTA0Njg3MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361966097498220783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "34.978674",
      "poi_longitude": "-81.0027444",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-324-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c46-76db-a45c-351d5865c0b2",
        "storage_key": "property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RYsSk-PVogR76gFAEQZzY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_9b2f19c2-ea69-4cf4-8276-9ffbc84a11f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2750 Celanese Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-a1b3-754a-b8b6-8245fb18b247.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-a1b3-754a-b8b6-8245fb18b247",
        "storage_key": "property/6767906449164261/019e1dd7-a1b3-754a-b8b6-8245fb18b247.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/sc/rock-hill/northwoods-square/097/00149?cid=loc_09700149_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17241822137475296779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "34.9770811",
      "poi_longitude": "-81.02792409999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-329-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c46-76db-a45c-351d5865c0b2",
        "storage_key": "property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEy_J3yuPVogRC26uCOJBR-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_60655909-6945-4c82-b1c6-33d6b10d79a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "4952 Old York Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd7-be42-7789-8f5a-998695caa1f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-be42-7789-8f5a-998695caa1f1",
        "storage_key": "property/6767906449164261/019e1dd7-be42-7789-8f5a-998695caa1f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/sc/rock-hill/4952-old-york-rd/f943",
      "poi_directions_map_url": "https://maps.google.com/?cid=2457938568259431795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "34.9829091",
      "poi_longitude": "-81.0916731",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c46-76db-a45c-351d5865c0b2",
        "storage_key": "property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6_VeXYSNVogRc-3V6BpaHCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_c4ef605e-245e-437d-9d89-34bdb678cdc7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2377 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Large retailer chain selling electronics, home goods, video games and clothing as well as groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-9ff8-74ac-8b5b-8d28ab92864f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-9ff8-74ac-8b5b-8d28ab92864f",
        "storage_key": "property/6767906449164261/019e1dd8-9ff8-74ac-8b5b-8d28ab92864f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/585-rock-hill-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6330082212652309828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "34.94377180000001",
      "poi_longitude": "-80.96318710000001",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-366-9431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEwrNvEGGVogRRN0o9Dv42Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_295e9a15-057f-461d-948c-e988e57764be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "2707 Celanese Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-1514-77f8-b1db-aab5a8d1b5d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-1514-77f8-b1db-aab5a8d1b5d5",
        "storage_key": "property/6767906449164261/019e1dd8-1514-77f8-b1db-aab5a8d1b5d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/rock-hill-sc-pharmacies/2707-celanese-rd-rock-hill-sc-29732/storeid=4288?WT.mc_id=LS_GOOGLE_FS_4288",
      "poi_directions_map_url": "https://maps.google.com/?cid=6845748737683630192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "34.9753723",
      "poi_longitude": "-81.0270738",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-366-4157",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22zW4CuPVogRcCg24zT8AF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_6c69ac60-3401-46cc-9a5f-da29e8f7aecb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1008 Oakland Ave #120, Rock Hill, SC 29732, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-d805-7178-8024-84179b3b1028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-d805-7178-8024-84179b3b1028",
        "storage_key": "property/6767906449164261/019e1dd8-d805-7178-8024-84179b3b1028.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1008+oakland+ave-rock+hill-sc-29732/id=4842",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010436881469512440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.9438571",
      "poi_longitude": "-81.0309479",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-980-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0gJAOKIVogR-JrZBQLuzJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_b5a21896-f5d3-40d3-80cd-34ed764bfb1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "1657 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-244f-703d-b90e-582e13d919e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-244f-703d-b90e-582e13d919e5",
        "storage_key": "property/6767906449164261/019e1dd8-244f-703d-b90e-582e13d919e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/sc/rock-hill/1657-cherry-rd-35567?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3533393282919804749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "34.9581652",
      "poi_longitude": "-81.0092925",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-366-3678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be6-7098-9071-4a6060f4d65d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be6-7098-9071-4a6060f4d65d",
        "storage_key": "property/6767906449164261/019e1dd9-1be6-7098-9071-4a6060f4d65d.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJP7JJ98eIVogRTa8vWHgiCTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_23b69d2c-d37c-440a-82bb-45e4459aa5ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "2541 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-4b96-7093-848e-2d0bba46e8ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-4b96-7093-848e-2d0bba46e8ed",
        "storage_key": "property/6767906449164261/019e1dd8-4b96-7093-848e-2d0bba46e8ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/rock-hill/2541-cherry-rd/2723932?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16052679448950207008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "34.9715886",
      "poi_longitude": "-80.9908238",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-324-2612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be6-7098-9071-4a6060f4d65d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be6-7098-9071-4a6060f4d65d",
        "storage_key": "property/6767906449164261/019e1dd9-1be6-7098-9071-4a6060f4d65d.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJjaRIrC6PVogRIPLjd-iSxt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_bd4a21f9-246c-408f-aab9-c4b97dd9869c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Old Pointe Elementary School",
      "poi_type": "Education",
      "poi_address": "380 Old Pointe School Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-203e-71af-ac65-dc5363db30b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-203e-71af-ac65-dc5363db30b3",
        "storage_key": "property/6767906449164261/019e1dd8-203e-71af-ac65-dc5363db30b3.webp",
        "width": 828,
        "height": 609
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4410530527382675577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-pointe-elementary-school",
      "poi_latitude": "34.9732107",
      "poi_longitude": "-81.0785563",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 803-980-2040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy2CCkf6LVogReSCpiyVaNT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_750bedab-09c9-465c-ab61-0586b46c9aa0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Mt. Gallant Elementary School",
      "poi_type": "Education",
      "poi_address": "4664 Mt Gallant Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rock-hill.k12.sc.us/Domain/16",
      "poi_directions_map_url": "https://maps.google.com/?cid=15290552899921280414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mt-gallant-elementary-school",
      "poi_latitude": "35.0117691",
      "poi_longitude": "-81.061925",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-981-1360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm5_zkGKPVogRnn0gg9n0MtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_be8fa6ae-01e1-4d78-b1b1-7c7e5c3128b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "India Hook Elementary School",
      "poi_type": "Education",
      "poi_address": "2068 Yukon Drive, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-43ca-7389-8c82-195a5d7a10eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-43ca-7389-8c82-195a5d7a10eb",
        "storage_key": "property/6767906449164261/019e1dd8-43ca-7389-8c82-195a5d7a10eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ihes.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17421369721207790122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "india-hook-elementary-school",
      "poi_latitude": "35.0032122",
      "poi_longitude": "-81.02237819999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-985-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlytyQwOPVogRKhpWhXUjxfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_495cd0e4-d9ae-4c69-a48a-ec7f5ccd2e74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "York Road Elementary School",
      "poi_type": "Education",
      "poi_address": "2254 W Main St, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rock-hill.k12.sc.us/Domain/24",
      "poi_directions_map_url": "https://maps.google.com/?cid=3042492298906368339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-road-elementary-school",
      "poi_latitude": "34.9479523",
      "poi_longitude": "-81.0739041",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 803-981-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhUcG7WGJVogRU_ksRKAaOSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f132b5f3-4684-4992-8101-6899493efa24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Cherry Park Elementary School of Language Immersion",
      "poi_type": "Education",
      "poi_address": "1835 Eden Terrace, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-3d21-77ce-89ec-1675a9c3617b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-3d21-77ce-89ec-1675a9c3617b",
        "storage_key": "property/6767906449164261/019e1dd8-3d21-77ce-89ec-1675a9c3617b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rock-hill.k12.sc.us/cherrypark",
      "poi_directions_map_url": "https://maps.google.com/?cid=15534764999213628445&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-park-elementary-school-of-language-immersion",
      "poi_latitude": "34.9589285",
      "poi_longitude": "-81.00550779999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-985-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF1dU7V6JVogRHbxMx3WSltc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c1928055-2dbf-43ec-b22f-ec9e4e38cacf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Sullivan Middle School",
      "poi_type": "Education",
      "poi_address": "1825 Eden Terrace, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://slms.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4156316325215135103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivan-middle-school",
      "poi_latitude": "34.9582337",
      "poi_longitude": "-81.0041213",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-981-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI5Xb-7mIVogRf-WaOq0zrjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c55b83f2-b043-4724-9b84-06c3e7a4a8a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Dutchman Creek Middle School",
      "poi_type": "Education",
      "poi_address": "4757 Mt Gallant Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rock-hill.k12.sc.us/Domain/26",
      "poi_directions_map_url": "https://maps.google.com/?cid=17516740201091065649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutchman-creek-middle-school",
      "poi_latitude": "35.0082507",
      "poi_longitude": "-81.0660345",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-985-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf5Z7sq-PVogRMWfWvGf2F_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7d1f3467-26ed-45e5-9eb7-00208025f37b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rawlinson Road Middle School",
      "poi_type": "Education",
      "poi_address": "2631 W Main St, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://rr.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14337323754546630500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rawlinson-road-middle-school",
      "poi_latitude": "34.9515124",
      "poi_longitude": "-81.08749689999999",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 803-981-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp-cDTN2LVogRZI-FC_5n-MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_819f1de8-5a47-470d-b7a4-944d1887c05e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Northwestern High School",
      "poi_type": "Education",
      "poi_address": "2503 W Main St, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-3817-7059-b6f9-4300e699baeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-3817-7059-b6f9-4300e699baeb",
        "storage_key": "property/6767906449164261/019e1dd8-3817-7059-b6f9-4300e699baeb.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://nwhs.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16834283851286904005&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwestern-high-school",
      "poi_latitude": "34.9502215",
      "poi_longitude": "-81.08301449999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 803-981-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD5_0sd2LVogRxfwMjPhjn-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f1278a61-8bcc-48a6-950b-0d8772273edd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "The Goddard School of Rock Hill",
      "poi_type": "Education",
      "poi_address": "415 Clouds Way, Rock Hill, SC 29732, USA",
      "poi_short_description": "Day care, preschool, and kindergarten-prep center with caring staff and security features.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-3bb6-70f4-80b5-41fd62db603a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-3bb6-70f4-80b5-41fd62db603a",
        "storage_key": "property/6767906449164261/019e1dd8-3bb6-70f4-80b5-41fd62db603a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.goddardschool.com/schools/sc/rock-hill/rock-hill?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=5821270933912023239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-rock-hill",
      "poi_latitude": "34.9610314",
      "poi_longitude": "-81.04383299999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-328-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2SCwncaIVogRx_AhbRJPyVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c5194a07-4499-4407-a4ba-d78fd6509db5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Regal Manchester - Rock Hill",
      "poi_type": "Entertainment",
      "poi_address": "1935 Cinema Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-ed78-74a5-ab76-342a390039f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-ed78-74a5-ab76-342a390039f5",
        "storage_key": "property/6767906449164261/019e1dd8-ed78-74a5-ab76-342a390039f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-manchester-rock-hill-1886?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11380516726765489096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-manchester---rock-hill",
      "poi_latitude": "34.944534",
      "poi_longitude": "-80.97834999999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bfc-700e-8d57-39829464f50a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bfc-700e-8d57-39829464f50a",
        "storage_key": "property/6767906449164261/019e1dd9-1bfc-700e-8d57-39829464f50a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WLmkSKGVogRyIs_m6q3750",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_857b8204-dfe1-4338-9a0c-3050f434a12c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Old Town Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "144 E Black St, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-f343-7699-8e52-127a244e7a4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-f343-7699-8e52-127a244e7a4d",
        "storage_key": "property/6767906449164261/019e1dd8-f343-7699-8e52-127a244e7a4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=982542593004156025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-amphitheater",
      "poi_latitude": "34.9244079",
      "poi_longitude": "-81.0281906",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOWvZsVWIVogReTS0WEixog0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_18064eef-a8d6-4392-9c2c-b0ed3f28ad2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Winthrop Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "1162 Eden Terrace, Rock Hill, SC 29730, USA",
      "poi_short_description": "Located inside the Winthrop Coliseum, this arena has hosted events such as graduations and competitions, and has well-regarded seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-938d-717f-bf1f-55d546b2a846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-938d-717f-bf1f-55d546b2a846",
        "storage_key": "property/6767906449164261/019e1dd6-938d-717f-bf1f-55d546b2a846.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.winthrop.edu/virtualtour/farm-area-tour-coliseum.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16608227684221378221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winthrop-coliseum",
      "poi_latitude": "34.9481381",
      "poi_longitude": "-81.0149285",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-323-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoxEgdMKIVogRrd7SqhVHfOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_61800ad1-53b2-44b9-8ca7-85a2142a1b59",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Museum of York County",
      "poi_type": "Entertainment",
      "poi_address": "4621 Mt Gallant Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Heritage museum with a naturalist center & hands-on programs, plus specimens, a planetarium & store.",
      "poi_long_description": "Heritage museum with a naturalist center & hands-on programs, plus specimens, a planetarium & store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-d712-727e-84e0-5331876542b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd5-d712-727e-84e0-5331876542b4",
        "storage_key": "property/6767906449164261/019e1dd5-d712-727e-84e0-5331876542b4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://chmuseums.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11863472374095991765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-york-county",
      "poi_latitude": "35.0100332",
      "poi_longitude": "-81.0628414",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-329-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c53-765a-85af-d3f6717f7db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c53-765a-85af-d3f6717f7db5",
        "storage_key": "property/6767906449164261/019e1dd9-1c53-765a-85af-d3f6717f7db5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Ydzro6OVogR1dOm1ESFo6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_55e50b61-38e2-47b7-b48c-8d33870e0031",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Main Street Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "133 E Main St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Whimsical, artist-inspired venue offering imaginative & interactive activities for kids.",
      "poi_long_description": "Whimsical, artist-inspired venue offering imaginative & interactive activities for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-0586-7662-a4e4-ad44b6cd8a8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0586-7662-a4e4-ad44b6cd8a8f",
        "storage_key": "property/6767906449164261/019e1dd9-0586-7662-a4e4-ad44b6cd8a8f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.chmuseums.org/childrens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1870870005868144602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-childrens-museum",
      "poi_latitude": "34.9256809",
      "poi_longitude": "-81.026816",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-327-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c53-765a-85af-d3f6717f7db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c53-765a-85af-d3f6717f7db5",
        "storage_key": "property/6767906449164261/019e1dd9-1c53-765a-85af-d3f6717f7db5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2Lu6lWIVogR2ie0qFuq9hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_78157e49-8fd4-49c3-b0eb-65adb52cf807",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Comporium Telephone Museum",
      "poi_type": "Entertainment",
      "poi_address": "117 Elk Avenue, Rock Hill, SC 29730, USA",
      "poi_short_description": "Modest museum offering a compact gallery with old telephones, a switchboard & audio/video displays.",
      "poi_long_description": "Modest museum offering a compact gallery with old telephones, a switchboard & audio/video displays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-8464-767e-862a-425c682c6c50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-8464-767e-862a-425c682c6c50",
        "storage_key": "property/6767906449164261/019e1dd8-8464-767e-862a-425c682c6c50.webp",
        "width": 1240,
        "height": 700
      },
      "poi_business_url": "https://about.comporium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8999774755858441115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comporium-telephone-museum",
      "poi_latitude": "34.9249762",
      "poi_longitude": "-81.0274298",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-324-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c53-765a-85af-d3f6717f7db5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c53-765a-85af-d3f6717f7db5",
        "storage_key": "property/6767906449164261/019e1dd9-1c53-765a-85af-d3f6717f7db5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJF5a8sFWIVogRm2N4JXWf5Xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7cc673a0-4348-4168-b4a7-6b4fba68ecfe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Player 1UP",
      "poi_type": "Entertainment",
      "poi_address": "140 E Main St Suite 140, Rock Hill, SC 29730, USA",
      "poi_short_description": "Video arcade featuring pinball, retro games, and air hockey, plus pizza and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-c01f-7748-810a-b26f202f34c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-c01f-7748-810a-b26f202f34c2",
        "storage_key": "property/6767906449164261/019e1dd8-c01f-7748-810a-b26f202f34c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.player1up.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16473899859097479303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "player-1up",
      "poi_latitude": "34.9251465",
      "poi_longitude": "-81.0271605",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-327-6407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2Nd1s6JVogRh-jcrqMMn-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_d69a258a-0260-40cb-95fc-fe066fb1f17d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Tattooed Brews",
      "poi_type": "Entertainment",
      "poi_address": "120 E Main St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Bar and grill offering quick bites, cocktails, and live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-cdb4-725f-b578-abd080f0d18d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-cdb4-725f-b578-abd080f0d18d",
        "storage_key": "property/6767906449164261/019e1dd8-cdb4-725f-b578-abd080f0d18d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/tattooedbrews/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1445466105487382651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tattooed-brews",
      "poi_latitude": "34.9256623",
      "poi_longitude": "-81.02746979999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-329-7737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bf8-76d1-85b4-54976255e477",
        "storage_key": "property/6767906449164261/019e1dd9-1bf8-76d1-85b4-54976255e477.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQXoRKCJVogRe1hxuMNTDxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_469e2896-b9a5-4ee2-942f-78e962b0aa3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill Velodrome",
      "poi_type": "Entertainment",
      "poi_address": "1000 Riverwalk Parkway, Rock Hill, SC 29730, USA",
      "poi_short_description": "Sports complex featuring a velodrome for bicycle races plus dirt bike and mountain bike trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-c77b-77b8-a56e-eca983e286b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-c77b-77b8-a56e-eca983e286b6",
        "storage_key": "property/6767906449164261/019e1dd8-c77b-77b8-a56e-eca983e286b6.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.cityofrockhill.com/departments/parks-recreation-tourism/parks-facilities/regional-parks/rock-hill-velodrome",
      "poi_directions_map_url": "https://maps.google.com/?cid=6821330933119953036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-hill-velodrome",
      "poi_latitude": "34.9761771",
      "poi_longitude": "-80.9776969",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-326-2453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhbDMmfqFVogRjKj_u1c8ql4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_2dc619d0-3ae2-403b-b090-8f09ed7e8963",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Piedmont Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "222 S Herlong Ave, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-b8de-77e7-889d-88cb71c1e6ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-b8de-77e7-889d-88cb71c1e6ce",
        "storage_key": "property/6767906449164261/019e1dd6-b8de-77e7-889d-88cb71c1e6ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmontmedicalcenter.com/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-piedmontmc-rockhill&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4319733036252752549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-medical-center",
      "poi_latitude": "34.956872",
      "poi_longitude": "-81.0507432",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-329-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2100-749d-b6f7-bc56b90d3af5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2100-749d-b6f7-bc56b90d3af5",
        "storage_key": "property/6767906449164261/019e1dd9-2100-749d-b6f7-bc56b90d3af5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRei2DiJVogRpWpdPk_G8js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_2e360582-7436-4362-80d8-57d0d6dcf578",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1656 Riverchase Blvd #1800, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-d01e-7208-85bd-d84737a0f04a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-d01e-7208-85bd-d84737a0f04a",
        "storage_key": "property/6767906449164261/019e1dd8-d01e-7208-85bd-d84737a0f04a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-rock-hill?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=1046285683438571616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "34.98007820000001",
      "poi_longitude": "-80.98926569999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-909-1850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw176eSuPVogRYNDuHkknhQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_05d1aad0-a300-45b1-b883-a2cc147079bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Riverview Family Medicine",
      "poi_type": "Health and Wellness",
      "poi_address": "2450 India Hook Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-d9dd-76fd-bd74-8af3a9edb105.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-d9dd-76fd-bd74-8af3a9edb105",
        "storage_key": "property/6767906449164261/019e1dd8-d9dd-76fd-bd74-8af3a9edb105.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://riverviewfamilymedicine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15237508334943862299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-family-medicine",
      "poi_latitude": "34.9748088",
      "poi_longitude": "-81.02638040000001",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-366-7443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2VTIBmPVogRG_5hThmBdtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_7bcf4a05-9150-47d8-9690-e3f01b1a93ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1008 Oakland Ave #120, Rock Hill, SC 29732, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-e2ed-7798-9a7c-6d28396bee2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-e2ed-7798-9a7c-6d28396bee2b",
        "storage_key": "property/6767906449164261/019e1dd8-e2ed-7798-9a7c-6d28396bee2b.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1008+oakland+ave-rock+hill-sc-29732/id=4842",
      "poi_directions_map_url": "https://maps.google.com/?cid=9627931448825036294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "34.9438355",
      "poi_longitude": "-81.0309834",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-980-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-20f9-7649-a98f-10c5555eb471.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-20f9-7649-a98f-10c5555eb471",
        "storage_key": "property/6767906449164261/019e1dd9-20f9-7649-a98f-10c5555eb471.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTLL_uGIVogRBj4HSaRInYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f629cd45-000d-49f6-ae36-1714f85080cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1807 Cherry Rd Ste 115, Rock Hill, SC 29732, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, plus tanning beds, massage chairs, and showers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-5d9a-707b-9e9b-aa0236e4952a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-5d9a-707b-9e9b-aa0236e4952a",
        "storage_key": "property/6767906449164261/019e1dd6-5d9a-707b-9e9b-aa0236e4952a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/rock-hill-sc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3357048731008634616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.9616543",
      "poi_longitude": "-81.0069615",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-328-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKyOrmLeIVogR-A5y0Qiili4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_693dc401-26f0-4fc8-9743-ad277d6b69b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "745 Arden Ln, Rock Hill, SC 29732, USA",
      "poi_short_description": "Relaxed, spacious gym with a basketball court, a pool and cardio machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-5e53-772e-9a07-38eac7820992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-5e53-772e-9a07-38eac7820992",
        "storage_key": "property/6767906449164261/019e1dd6-5e53-772e-9a07-38eac7820992.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1155&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1512700271969287128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "34.9599789",
      "poi_longitude": "-81.0438312",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-818-3368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ZDDvDqJVogR2Ltd-uEw_hQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6a7ffb32-e8c8-4ee4-9fee-cca03fde74b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "RockBox Fitness Riverwalk",
      "poi_type": "Health and Wellness",
      "poi_address": "652 Herrons Ferry Road #107, Rock Hill, SC 29730, USA",
      "poi_short_description": "Gym also featuring 50-minute high-energy kickboxing classes that blend strength training and functional exercise.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-e6ba-726a-952f-d5d8037040dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-e6ba-726a-952f-d5d8037040dc",
        "storage_key": "property/6767906449164261/019e1dd8-e6ba-726a-952f-d5d8037040dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rockboxfitness.com/locations/riverwalk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17058944944306347132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockbox-fitness-riverwalk",
      "poi_latitude": "34.9833421",
      "poi_longitude": "-80.9718103",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-457-8090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo0pVaxSFVogRfFxTcAuMvew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_coaching"
    },
    {
      "id": "custom_57ae9e36-477f-444b-807e-1de300f57d0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Southern Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "727 Dilworth Ln, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-edd5-763f-8544-ad74e4e5eabe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-edd5-763f-8544-ad74e4e5eabe",
        "storage_key": "property/6767906449164261/019e1dd8-edd5-763f-8544-ad74e4e5eabe.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://southernyogastudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6170880265022646413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southern-yoga-studio",
      "poi_latitude": "34.9638812",
      "poi_longitude": "-81.0338628",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-579-5022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOxTAS2yJVogRjagkBOheo1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_e2f52f09-261c-4795-9214-8ff34063f30b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1782 Quality Cir, Rock Hill, SC 29730, USA",
      "poi_short_description": "Natural parkland ranging across 70 acres along the  Catawba River, with trails & a boat launch.",
      "poi_long_description": "Natural parkland ranging across 70 acres along the  Catawba River, with trails & a boat launch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-f529-718c-b8bc-dbdf7c8e7269.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-f529-718c-b8bc-dbdf7c8e7269",
        "storage_key": "property/6767906449164261/019e1dd8-f529-718c-b8bc-dbdf7c8e7269.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/102/8146",
      "poi_directions_map_url": "https://maps.google.com/?cid=9938634470194700508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-hill-river-park",
      "poi_latitude": "34.9526432",
      "poi_longitude": "-80.95509369999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-329-5632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZmbdHuGVogR3GBovGQf7Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0e834bd9-e289-4b72-b800-798be56001f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Piedmont Medical Center Trail - North Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "575 Herrons Ferry Road, Rock Hill, SC 29730, USA",
      "poi_short_description": "Paved trail alongside the Catawba River with benches for resting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-f6b0-7156-9a28-0c895a924957.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-f6b0-7156-9a28-0c895a924957",
        "storage_key": "property/6767906449164261/019e1dd8-f6b0-7156-9a28-0c895a924957.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14178813265324863108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-medical-center-trail---north-trailhead",
      "poi_latitude": "34.98376289999999",
      "poi_longitude": "-80.973041",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTT6LeyFVogRhO5I0IpDxcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_47505ec7-8fce-43c1-a3e4-327897690cca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "River District at Riverwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "652 Herrons Ferry Road Suite 106, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-f2d9-76d4-aa9c-aa3a38bbd6be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-f2d9-76d4-aa9c-aa3a38bbd6be",
        "storage_key": "property/6767906449164261/019e1dd8-f2d9-76d4-aa9c-aa3a38bbd6be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.riverwalkcarolinas.com/district.php?River-District-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=5389922120926643896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-district-at-riverwalk",
      "poi_latitude": "34.9832204",
      "poi_longitude": "-80.9715529",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-392-3999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMwnpJeyFVogRuEbaqJzZzEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ac0a7671-6c1d-46fc-938d-3eff41519f3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Glencairn Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "725 Crest St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Quaint park featuring landscaped gardens & lawns, a variety of blooming flowers & a spring festival.",
      "poi_long_description": "Quaint park featuring landscaped gardens & lawns, a variety of blooming flowers & a spring festival.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-d51c-717b-a23a-784431c186b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-d51c-717b-a23a-784431c186b8",
        "storage_key": "property/6767906449164261/019e1dd6-d51c-717b-a23a-784431c186b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.visityorkcounty.com/things-to-do/outdoors/glencairn-garden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=985369489744163701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glencairn-garden",
      "poi_latitude": "34.9340692",
      "poi_longitude": "-81.02000009999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-329-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wzRCvqIVogRdXO1iFS8rA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cdcb49c6-3769-48bb-b939-740d8521cb60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Fountain Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 E Main St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Community area with a lawn & event space, plus a circular fountain with illuminated displays.",
      "poi_long_description": "Community area with a lawn & event space, plus a circular fountain with illuminated displays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-f520-708f-9a0e-92d52df91f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-f520-708f-9a0e-92d52df91f8e",
        "storage_key": "property/6767906449164261/019e1dd8-f520-708f-9a0e-92d52df91f8e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/61/151",
      "poi_directions_map_url": "https://maps.google.com/?cid=1645800211807415494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fountain-park",
      "poi_latitude": "34.9233211",
      "poi_longitude": "-81.02446800000001",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-329-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wqoklaIVogRxiwLpJIO1xY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_fe85af01-296b-4d96-ba2c-15bff63d0ee5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Miracle Park of Rock Hill",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1005 Eden Terrace, Rock Hill, SC 29730, USA",
      "poi_short_description": "Park with a playground, picnic areas, a baseball field, and a sensory play area, plus a zip line.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-ff5e-76ec-8a9b-5fad590d74f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-ff5e-76ec-8a9b-5fad590d74f8",
        "storage_key": "property/6767906449164261/019e1dd8-ff5e-76ec-8a9b-5fad590d74f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.miracleparkrockhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791278676723868599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miracle-park-of-rock-hill",
      "poi_latitude": "34.9481514",
      "poi_longitude": "-81.0213942",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-329-7079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbaogCB6JVogRt6NfJshSwpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eb24e650-7869-434b-9c20-5b9be51085f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Cherry Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1466 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Green space, a 1.5-mile trail, picnic areas & fields, including 5 baseball diamonds, on 68 acres.",
      "poi_long_description": "Green space, a 1.5-mile trail, picnic areas & fields, including 5 baseball diamonds, on 68 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-be89-7449-b720-88ba6faef2c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-be89-7449-b720-88ba6faef2c7",
        "storage_key": "property/6767906449164261/019e1dd6-be89-7449-b720-88ba6faef2c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/34/151",
      "poi_directions_map_url": "https://maps.google.com/?cid=4730073361904011713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-park",
      "poi_latitude": "34.9536327",
      "poi_longitude": "-81.0113252",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-329-5672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvexwb8eIVogRwYnTYamYpEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8605d3d5-4898-44a1-ac5e-cf73f43d7581",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Ebenezer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4490 Boatshore Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Lakefront campground with RV pads, a boat launch, playgrounds, a swimming area and beaches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-f9ed-741b-8123-83e9a40c92b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-f9ed-741b-8123-83e9a40c92b6",
        "storage_key": "property/6767906449164261/019e1dd8-f9ed-741b-8123-83e9a40c92b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yorkcountygov.com/212/Ebenezer-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6510071875477827266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ebenezer-park",
      "poi_latitude": "35.022228",
      "poi_longitude": "-81.04283459999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-366-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1Re51mOVogRwu4dAOFrWFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8988bf8f-9569-4d3c-a883-7d08375c4427",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Manchester Meadows Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "337 E Mt Gallant Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "City park with multiple soccer fields, a playground & sheltered picnic areas, plus walking trails.",
      "poi_long_description": "City park with multiple soccer fields, a playground & sheltered picnic areas, plus walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-cbce-748b-9b0c-4bc333ff21de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-cbce-748b-9b0c-4bc333ff21de",
        "storage_key": "property/6767906449164261/019e1dd6-cbce-748b-9b0c-4bc333ff21de.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/12/8145",
      "poi_directions_map_url": "https://maps.google.com/?cid=9700416392351357493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manchester-meadows-park",
      "poi_latitude": "34.9440169",
      "poi_longitude": "-80.98360319999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-326-3792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz9hnciCGVogRNZp6V1DNnoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_63314fb2-07ad-4119-9b1a-eb7cc03185c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Spencer Park Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Spencer St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Popular fenced areas for dogs (separated by size) with water fountains, as well as playgrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-04d2-7218-9b68-0fd2986d8b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-04d2-7218-9b68-0fd2986d8b4b",
        "storage_key": "property/6767906449164261/019e1dd9-04d2-7218-9b68-0fd2986d8b4b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/157/173",
      "poi_directions_map_url": "https://maps.google.com/?cid=14846087358572095578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spencer-park-dog-park",
      "poi_latitude": "34.9227847",
      "poi_longitude": "-81.0055406",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-329-5632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8FbgWeJVogRWmgbcMvlB84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_92395490-470d-4193-a1da-92905635c3a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "My Ride Transit Hub",
      "poi_type": "Transportation & Transit",
      "poi_address": "343 Technology Center Way, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd8-ff71-700a-9ffb-b583d395a85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd8-ff71-700a-9ffb-b583d395a85a",
        "storage_key": "property/6767906449164261/019e1dd8-ff71-700a-9ffb-b583d395a85a.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://myriderockhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=593617983546099041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "my-ride-transit-hub",
      "poi_latitude": "34.9328765",
      "poi_longitude": "-81.0315353",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 803-329-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIUiwbO-JVogRYYWMMWn0PAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_04377042-d8b2-4394-8792-c5a7f0d72612",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "White Street Parking Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "120 E White St, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=734355775054290157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-street-parking-lot",
      "poi_latitude": "34.92677",
      "poi_longitude": "-81.0275827",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-214b-74bf-a200-abbbada50739.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-214b-74bf-a200-abbbada50739",
        "storage_key": "property/6767906449164261/019e1dd9-214b-74bf-a200-abbbada50739.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRZziVWIVogR7Rzexq_0MAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_53b2f5dd-2d29-4881-981b-bfad66441170",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill Galleria",
      "poi_type": "Entertainment",
      "poi_address": "2301 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Modest enclosed mall drawing locals since 1991 for its large anchor stores & varied specialty shops.",
      "poi_long_description": "Modest enclosed mall drawing locals since 1991 for its large anchor stores & varied specialty shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-07e8-77ed-ac09-089e43bc9278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-07e8-77ed-ac09-089e43bc9278",
        "storage_key": "property/6767906449164261/019e1dd9-07e8-77ed-ac09-089e43bc9278.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rockhillgalleria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13135205956569526276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-hill-galleria",
      "poi_latitude": "34.9432563",
      "poi_longitude": "-80.96582719999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "80",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-324-1711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG14BhUCGVogRBPDrZDmgSbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9f4339bf-4ce2-4117-b948-6c95b125cdf3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill - York County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "550 Airport Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-d5ed-7179-96b6-cc5b0def93b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-d5ed-7179-96b6-cc5b0def93b9",
        "storage_key": "property/6767906449164261/019e1dd6-d5ed-7179-96b6-cc5b0def93b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofrockhill.com/departments/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=3344458451790801171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-hill---york-county-airport",
      "poi_latitude": "34.9871306",
      "poi_longitude": "-81.0601092",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-329-5560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-21be-7148-b6bb-e6b819491352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-21be-7148-b6bb-e6b819491352",
        "storage_key": "property/6767906449164261/019e1dd9-21be-7148-b6bb-e6b819491352.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3ukF7mOVogREykLAT7naS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a04a5ca5-b5b4-4d2f-a560-b642099da3d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-0e99-75bb-8b54-5354c4cd4fa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0e99-75bb-8b54-5354c4cd4fa0",
        "storage_key": "property/6767906449164261/019e1dd9-0e99-75bb-8b54-5354c4cd4fa0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "20.4",
      "poi_walking_minutes": "7 hours 31 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-21be-7148-b6bb-e6b819491352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-21be-7148-b6bb-e6b819491352",
        "storage_key": "property/6767906449164261/019e1dd9-21be-7148-b6bb-e6b819491352.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_95fc4670-5493-4e4d-b457-37cbd929c4a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Winthrop University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 Oakland Ave, Rock Hill, SC 29733, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-9134-76db-848f-32aa16ee64b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-9134-76db-848f-32aa16ee64b5",
        "storage_key": "property/6767906449164261/019e1dd6-9134-76db-848f-32aa16ee64b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.winthrop.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12948757423612692395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winthrop-university",
      "poi_latitude": "34.9394013",
      "poi_longitude": "-81.03199699999999",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-323-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6__1m-KIVogRqwcjdUU6s7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_01a087d1-1c2c-4a31-8419-53872fd9904b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Comporium Corporate Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "330 E Black St, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-0b0d-73ae-a9af-a77120625d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0b0d-73ae-a9af-a77120625d0c",
        "storage_key": "property/6767906449164261/019e1dd9-0b0d-73ae-a9af-a77120625d0c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.comporium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13730688602750439451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comporium-corporate-offices",
      "poi_latitude": "34.922401",
      "poi_longitude": "-81.0243825",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 888-403-2667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTF9_VaIVogRG9BxMIk0jb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_c2c135c1-93d6-4ffa-b492-6b1cf82ced55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "3D Systems, Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "333 Three D Systems Cir, 333 Three D Systems Cir, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-0c62-75b6-bc27-4814f503e8e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0c62-75b6-bc27-4814f503e8e8",
        "storage_key": "property/6767906449164261/019e1dd9-0c62-75b6-bc27-4814f503e8e8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.3dsystems.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18142908880126513209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3d-systems-corporate-headquarters",
      "poi_latitude": "34.9503601",
      "poi_longitude": "-80.94928329999999",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-326-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2wXn2aGVogROZA4UICPyPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_5d55e088-c6a2-4d42-85de-56ba398e9c89",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "386 E Black St, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-0ec8-74cb-9974-994bd01e8b50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-0ec8-74cb-9974-994bd01e8b50",
        "storage_key": "property/6767906449164261/019e1dd9-0ec8-74cb-9974-994bd01e8b50.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7519286559586590375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-hill-schools",
      "poi_latitude": "34.92178570000001",
      "poi_longitude": "-81.0230563",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-981-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_____6SIVogRpx6HfEnfWWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f789b9b2-3148-47db-990a-45e56f8840cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "155 Johnston St, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-e7bd-727c-8102-4ea459f9e1fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-e7bd-727c-8102-4ea459f9e1fd",
        "storage_key": "property/6767906449164261/019e1dd6-e7bd-727c-8102-4ea459f9e1fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofrockhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=276421897053593666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-hill-city-hall",
      "poi_latitude": "34.9240139",
      "poi_longitude": "-81.0282017",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-325-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-22d9-742e-b58b-1e9e9f924e1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-22d9-742e-b58b-1e9e9f924e1d",
        "storage_key": "property/6767906449164261/019e1dd9-22d9-742e-b58b-1e9e9f924e1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RnY6FSIVogRQuAENkAM1gM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_9812e34c-6e3e-403d-9a2e-439de37b0468",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "YORK COUNTY OFFICE COMPLEX",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1070 Heckle Blvd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-133e-771f-b383-3cfe32eb27db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-133e-771f-b383-3cfe32eb27db",
        "storage_key": "property/6767906449164261/019e1dd9-133e-771f-b383-3cfe32eb27db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yorkcountygov.com/Directory.aspx?did=8",
      "poi_directions_map_url": "https://maps.google.com/?cid=7801575834041710245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "york-county-office-complex",
      "poi_latitude": "34.9371268",
      "poi_longitude": "-81.0582556",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QKd2nOJVogRpfZT9OLDRGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_4ca32d62-32db-4678-9321-dfcae02af2cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Atlas Copco Compressors LLC - Corporate HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Technology Center Way Suite 550, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1293-73cf-b297-669e9f6d2412.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1293-73cf-b297-669e9f6d2412",
        "storage_key": "property/6767906449164261/019e1dd9-1293-73cf-b297-669e9f6d2412.webp",
        "width": 631,
        "height": 355
      },
      "poi_business_url": "https://www.atlascopco.com/en-us/compressors",
      "poi_directions_map_url": "https://maps.google.com/?cid=12037873355066963514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlas-copco-compressors-llc---corporate-hq",
      "poi_latitude": "34.931179",
      "poi_longitude": "-81.0300979",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 866-545-4999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73WvB2SGVogROvbnewkeD6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_ce53b060-6ae6-49d3-9b0b-4d47b1a54f2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "HS HYOSUNG USA, Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15801 Brixham Hill Ave #575, Charlotte, NC 28277, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1570-777f-a3ed-dca719d5deea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1570-777f-a3ed-dca719d5deea",
        "storage_key": "property/6767906449164261/019e1dd9-1570-777f-a3ed-dca719d5deea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.hyosungusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=547218824599272821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hs-hyosung-usa-inc",
      "poi_latitude": "35.0584286",
      "poi_longitude": "-80.8540321",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 704-790-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQJpeJdXIBURdX2lJp8cmAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_75811b4c-6d45-46af-a43d-25e3317ea6ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Moss Justice Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1675 York Hwy # 1D, York, SC 29745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.yorkcountysheriff.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4308256173844495073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moss-justice-center",
      "poi_latitude": "34.9824986",
      "poi_longitude": "-81.1996913",
      "poi_miles_from_property": "13.5",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 803-628-3059",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-22d9-742e-b58b-1e9e9f924e1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-22d9-742e-b58b-1e9e9f924e1d",
        "storage_key": "property/6767906449164261/019e1dd9-22d9-742e-b58b-1e9e9f924e1d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpf5MVn3zVogR4Xpi-ykAyjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_371b517b-6f07-436a-8b28-49fa207a6a24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping & Retail",
      "poi_address": "1260 Herrons Ferry Road, Rock Hill, SC 29730, USA",
      "poi_short_description": "Discount supermarket chain stocking a wide selection of organic and international products.",
      "poi_long_description": "People say this grocery store offers fresh produce, a great selection of baked goods, and a variety of affordable food and merchandise. They also highlight the good prices and helpful staff.\n\nSome reviews mention the self-checkout can be sensitive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-5d68-733f-8b57-22582d8de845.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-5d68-733f-8b57-22582d8de845",
        "storage_key": "property/6767906449164261/019ff7af-5d68-733f-8b57-22582d8de845.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lidl.com/s/en-US/stores/rock-hill/herrons-ferry-road-1260/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8703542600193277395&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "34.9781821",
      "poi_longitude": "-80.9803293",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c46-76db-a45c-351d5865c0b2",
        "storage_key": "property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGb6AhuWFVogR0_3_q-ExyXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_208370f5-cdff-45a3-b5eb-99c840492b48",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Earth Fare",
      "poi_type": "Shopping & Retail",
      "poi_address": "725 Cherry Rd Ste 110, Rock Hill, SC 29730, USA",
      "poi_short_description": "Supermarket chain dedicated to health-conscious foods like organic produce & grass-fed beef.",
      "poi_long_description": "People say this grocery store offers a great selection of healthy food choices, including organic produce, meat, and unique condiments. They also highlight the friendly and helpful staff, and appreciate the prepared food and deli items.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-5cf2-706c-b231-34cf3bae19ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-5cf2-706c-b231-34cf3bae19ff",
        "storage_key": "property/6767906449164261/019ff7af-5cf2-706c-b231-34cf3bae19ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.earthfare.com/stores/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8085936563707433554&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "earth-fare",
      "poi_latitude": "34.9450157",
      "poi_longitude": "-81.02869849999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-792-0675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA0bbYhyJVogRUtIfrHYEN3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health_food_store"
    },
    {
      "id": "custom_d707b688-9c99-4313-96df-52539f3a08a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Las Americas Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1906 N, 1906 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Compact market offering a meat counter, produce, canned goods, snacks, Mexican food items, takeout fares and prepared dishes.",
      "poi_long_description": "People say this market offers delicious and authentic tacos, burritos, and tortas, with a wide variety of fresh meats and produce available in the grocery section. They also highlight the excellent value, especially the 50-cent tacos on Tuesdays, and the friendly, courteous staff. Visitors appreciate the lively, down-home atmosphere and the convenience of outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-2d71-775e-8635-babc4ce1ee40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-2d71-775e-8635-babc4ce1ee40",
        "storage_key": "property/6767906449164261/019e1dd6-2d71-775e-8635-babc4ce1ee40.webp",
        "width": 1280,
        "height": 1240
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=564657913861890352&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "las-americas-supermarket",
      "poi_latitude": "34.9609522",
      "poi_longitude": "-81.00365579999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-980-8151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c46-76db-a45c-351d5865c0b2",
        "storage_key": "property/6767906449164261/019e1dd9-1c46-76db-a45c-351d5865c0b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0631LaIVogRMOFZh2ER1gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_092c0558-ef48-4bc9-95cc-baeecc801d96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2815 Home Depot Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Customers consistently praise this store for being well-stocked and organized, offering a great selection of items including higher quality lumber and plants, alongside easy parking. The friendly and knowledgeable staff are also frequently highlighted as a positive aspect of the shopping experience.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-5914-734e-861c-f2bc04330b2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-5914-734e-861c-f2bc04330b2f",
        "storage_key": "property/6767906449164261/019ff7af-5914-734e-861c-f2bc04330b2f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Rock-Hill/SC/Rock-Hill/29730/1114?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9497073280658901818&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "34.9783353",
      "poi_longitude": "-80.98455899999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-909-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc3VNxfmFVogROguHw9RhzIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f015eaa6-ed62-4513-a67b-c485521a0c27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1350 Springdale Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Customers consistently praise this store for its wide selection of home improvement items, including appliances and plants, alongside its better displays compared to competitors. Reviewers also frequently highlight the friendly and knowledgeable staff, as well as the fast service they provide.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-5911-72ee-93cc-91d3c0474485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-5911-72ee-93cc-91d3c0474485",
        "storage_key": "property/6767906449164261/019ff7af-5911-72ee-93cc-91d3c0474485.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/SC-Rock-Hill/0416?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-416-_-na-_-0-_-0&y_source=1_MTE4NDA1Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1906610576749416304&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "34.9388718",
      "poi_longitude": "-80.9621459",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-3170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2yb0u0CGVogRcM8myDekdRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_7973516f-6cd5-443b-bbe3-7b945a45c393",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 Springsteen Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Customers consistently praise this store for its great selection of merchandise, including both clothes and food options. They also appreciate the friendly and helpful staff, clean restrooms, and the convenience of online ordering with in-store pickup.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-5d49-7266-9774-269115448aac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-5d49-7266-9774-269115448aac",
        "storage_key": "property/6767906449164261/019ff7af-5d49-7266-9774-269115448aac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/rock-hill/1371",
      "poi_directions_map_url": "https://maps.google.com/?cid=5851719844173323408&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "34.93889850000001",
      "poi_longitude": "-80.978044",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-985-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj2ydgiSGVogRkBwOzTF8NVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ce91689f-2ced-4831-b9a4-a7c43852c2d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "2474 Cross Pointe Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this store offers a wide variety of bulk items, including fresh food options, and features convenient Scan & Go and curbside services. They also highlight the friendly and helpful staff, clean environment, and good value.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-59d5-7420-8fe2-3d451868ca87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-59d5-7420-8fe2-3d451868ca87",
        "storage_key": "property/6767906449164261/019ff7af-59d5-7420-8fe2-3d451868ca87.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6236-rock-hill-sc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4743693866656580769&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "34.9385107",
      "poi_longitude": "-80.9584393",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-372-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvfWZ8EOGVogRocRDRXD81EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e1cc48e2-3920-41c2-b084-65f3997388ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Belk",
      "poi_type": "Shopping & Retail",
      "poi_address": "2251 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Longtime department store chain with brand-name clothing, accessories & cosmetics, plus housewares.",
      "poi_long_description": "People say this department store offers a wide selection of clothing and home goods, including the Free People brand. They also highlight the reasonable prices and great deals, with many mentioning they rarely pay full retail.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-5ed8-71ef-a3a4-f53dfdb4d50c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-5ed8-71ef-a3a4-f53dfdb4d50c",
        "storage_key": "property/6767906449164261/019ff7af-5ed8-71ef-a3a4-f53dfdb4d50c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.belk.com/store/belk-rock-hill-sc/?StoreID=581",
      "poi_directions_map_url": "https://maps.google.com/?cid=3178514215427737439&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belk",
      "poi_latitude": "34.942476",
      "poi_longitude": "-80.96645900000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-366-9471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ3anaz-GVogRX4cZpNZZHCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4c82c39d-ae5e-4c1c-9474-41da0ff6f11b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1522 Meeting Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a great selection of quality clothes and other items, and appreciate the convenient self-pickup for online orders. They also highlight the friendly and helpful staff, and the affordable prices.\n\nSome reviews mention there can be long lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-61f7-7333-af5d-594ba111a82c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-61f7-7333-af5d-594ba111a82c",
        "storage_key": "property/6767906449164261/019ff7af-61f7-7333-af5d-594ba111a82c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/sc/rockhill-1138.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6626790930814732113&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "34.9438689",
      "poi_longitude": "-80.9585742",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaZtUv0GGVogRUQf-xz0X91s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_20b5979d-71d8-4767-900c-b182e3bf7701",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "552 John Ross Pkwy, Rock Hill, SC 29730, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-60dd-74ef-9014-1b682163355f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-60dd-74ef-9014-1b682163355f",
        "storage_key": "property/6767906449164261/019ff7af-60dd-74ef-9014-1b682163355f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8561352750913785879&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tj-maxx",
      "poi_latitude": "34.9435541",
      "poi_longitude": "-80.97723289999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-985-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWwDQpCOGVogRF5AHi_cI0HY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_90a7c0d9-288b-4bdc-9740-365faaf3ff90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "548 John Ross Pkwy, Rock Hill, SC 29730, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Visitors say this store offers a huge selection of merchandise, including a wide variety of items and well-stocked shelves. They also highlight the friendly and professional staff, efficient checkout process, and ample parking.\n\nSome reviews mention there can be a high-pitched ringing sound.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6143-73d4-b582-6430a53e2a64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6143-73d4-b582-6430a53e2a64",
        "storage_key": "property/6767906449164261/019ff7af-6143-73d4-b582-6430a53e2a64.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14967223847750596376&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "34.942764",
      "poi_longitude": "-80.9768327",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-964-7291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU0WPsdGHVogRGPftLspCts8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_05b38eb9-a45d-4bd9-99a0-6e7c0f620710",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1775 Chamberside Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Customers consistently praise this electronics store for its wide selection of the latest technology and its well-stocked and organized environment. Reviewers also frequently mention the knowledgeable staff who provide excellent service.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6590-74dd-b8e5-949a47e3e8db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6590-74dd-b8e5-949a47e3e8db",
        "storage_key": "property/6767906449164261/019ff7af-6590-74dd-b8e5-949a47e3e8db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/sc/rock-hill/1775-chamberside-dr-894.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=12914473402035146212&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "34.938873",
      "poi_longitude": "-80.97709499999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-366-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2zqErySGVogR5A2JpSJtObM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_8dffb5a3-00d8-466d-8079-6d2aabc80180",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "2468 Cross Pointe Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Customers consistently praise this sporting goods store for its wide selection of products, encompassing firearms, fishing supplies, and apparel, all offered at good prices. Reviewers also frequently mention the knowledgeable staff.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-65ed-7539-9911-10f019ec6a2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-65ed-7539-9911-10f019ec6a2f",
        "storage_key": "property/6767906449164261/019ff7af-65ed-7539-9911-10f019ec6a2f.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/south-carolina/rock-hill/store-0137",
      "poi_directions_map_url": "https://maps.google.com/?cid=3067906374587311090&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports--outdoors",
      "poi_latitude": "34.9400511",
      "poi_longitude": "-80.957399",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-323-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuxQkcUGGVogR8uNu3Zdkkyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_a252611f-d5e5-4815-9c0f-042b777dfbf9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1110 Hospitality Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "People say this pet store offers a wide variety of products and services, including grooming, and has a good selection of fish and birds. They also highlight the friendly, helpful, and knowledgeable staff, as well as the clean and well-organized store.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-665f-74e6-80fd-d030b6be4156.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-665f-74e6-80fd-d030b6be4156",
        "storage_key": "property/6767906449164261/019ff7af-665f-74e6-80fd-d030b6be4156.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/sc/rock-hill-store0405.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=11240497426014603932&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "34.9778814",
      "poi_longitude": "-80.9825512",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-817-6610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF2wL6vmFVogRnApLsNpE_ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e99f7d67-4bf1-409c-a201-c58fc805c5fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2376 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6783-72d8-8718-9e020dd73782.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6783-72d8-8718-9e020dd73782",
        "storage_key": "property/6767906449164261/019ff7af-6783-72d8-8718-9e020dd73782.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/sc/rock-hill/2376-dave-lyle-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=337614619673771490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "34.9409546",
      "poi_longitude": "-80.96132329999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 839-248-1162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIQFUokGGVogR4j2iNLVyrwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_de30bb3d-0d0b-417c-8bb2-87763a0500ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Ashley Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "2197 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this furniture store offers a wide selection of quality furniture, including mattresses and bedroom sets, with many styles and color options. Visitors highlight the knowledgeable and patient staff who provide excellent, low-pressure service. They also appreciate the reasonable prices and helpful financing options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6844-754f-aa4c-aa2adf7f8a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6844-754f-aa4c-aa2adf7f8a3a",
        "storage_key": "property/6767906449164261/019ff7af-6844-754f-aa4c-aa2adf7f8a3a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://stores.ashleyfurniture.com/store/us/south-carolina/rock-hill/2197-dave-lyle-blvd/?utm_source=G&utm_medium=localSEO&utm_campaign=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=14814088839543644397&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ashley-store",
      "poi_latitude": "34.942527",
      "poi_longitude": "-80.96793799999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 839-213-5235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJldQKdWSHVogR7eATqE83ls0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_4fd14a3e-9619-4018-8a7e-55c4149ee458",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rack Room Shoes",
      "poi_type": "Shopping & Retail",
      "poi_address": "2331 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_long_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-69c4-7012-92c4-15174a324d36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-69c4-7012-92c4-15174a324d36",
        "storage_key": "property/6767906449164261/019ff7af-69c4-7012-92c4-15174a324d36.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.rackroomshoes.com/store/20?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=20",
      "poi_directions_map_url": "https://maps.google.com/?cid=12539700673528585552&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rack-room-shoes",
      "poi_latitude": "34.9413747",
      "poi_longitude": "-80.96407359999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-9899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bde-7649-8f31-86f7e6cd65a2",
        "storage_key": "property/6767906449164261/019e1dd9-1bde-7649-8f31-86f7e6cd65a2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV0tJiUCGVogRUN1lC1P3Ba4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_0aabbfa4-7b1c-49fe-916d-b6be9da6f4db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "KONNICHIWA ROCK HILL",
      "poi_type": "Restaurants",
      "poi_address": "1425 Riverchase Blvd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Japanese restaurant offers delicious and fresh sushi, including popular options like the Godzilla and Volcano rolls, along with hearty hibachi bowls and excellent crab rangoons. They also highlight the fair prices for large portions and the clean, inviting atmosphere. Guests mention the staff, especially Sam and Koi, provide attentive, friendly, and accommodating service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6c1f-713f-94d6-6e32db7d7213.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6c1f-713f-94d6-6e32db7d7213",
        "storage_key": "property/6767906449164261/019ff7af-6c1f-713f-94d6-6e32db7d7213.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://konnichiwarestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16945711847065591801&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "konnichiwa-rock-hill",
      "poi_latitude": "34.9775733",
      "poi_longitude": "-80.99198919999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-980-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxwCnVgCPVogR-R95hiRDK-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_020d623a-50aa-4d99-be46-60093fda9114",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Pita Express Mediterranean Grill",
      "poi_type": "Restaurants",
      "poi_address": "2751 Cherry Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this restaurant's delicious and fresh Mediterranean food, including flavorful wraps, shawarma, and poutine, with generous portions. They also highlight the excellent value and the welcoming, local-favorite vibe. Others mention the friendly and attentive staff, who provide great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6b5a-7277-989e-326cbb3fa1aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6b5a-7277-989e-326cbb3fa1aa",
        "storage_key": "property/6767906449164261/019ff7af-6b5a-7277-989e-326cbb3fa1aa.webp",
        "width": 799,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/p/Pita-Express-Rock-Hill-SC-61587390591772/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369646258894374011&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pita-express-mediterranean-grill",
      "poi_latitude": "34.9752361",
      "poi_longitude": "-80.98520429999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-4008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7UaJu1iFVogRe4Tb61Ri6I8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_f5fb89b7-0d6e-4189-936f-99d4c0dd544d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Hickory Tavern",
      "poi_type": "Restaurants",
      "poi_address": "2674 Celanese Rd Apt 101, Rock Hill, SC 29732, USA",
      "poi_short_description": "Sports bar & grill chain with an extensive menu of typical bar food & TVs galore.",
      "poi_long_description": "Diners praise this tavern's delicious food, particularly the wings, crab soup, and cedar plank salmon, and enjoy the great atmosphere. The friendly staff are also frequently mentioned for their excellent service.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6db4-7603-92ea-4873fb011367.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6db4-7603-92ea-4873fb011367",
        "storage_key": "property/6767906449164261/019ff7af-6db4-7603-92ea-4873fb011367.webp",
        "width": 1280,
        "height": 594
      },
      "poi_business_url": "https://www.thehickorytavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1546645389720333307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hickory-tavern",
      "poi_latitude": "34.9766025",
      "poi_longitude": "-81.0246322",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl96Sfi6PVogR-6vGl8nJdhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f4af403f-bce0-445b-bae6-36aec42e1efd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Kobe Japanese Steakhouse of Rock Hill",
      "poi_type": "Restaurants",
      "poi_address": "2685 Celanese Rd #112, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this restaurant offers delicious and fresh sushi, flavorful ramen, and well-seasoned hibachi dishes with generous portions. They also highlight the reasonable prices, especially for lunch specials, and the clean, inviting atmosphere. Visitors consistently praise the friendly, attentive, and efficient staff, noting their welcoming service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6d48-70c8-86d9-53c41fa96bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6d48-70c8-86d9-53c41fa96bf1",
        "storage_key": "property/6767906449164261/019ff7af-6d48-70c8-86d9-53c41fa96bf1.webp",
        "width": 1280,
        "height": 860
      },
      "poi_business_url": "https://koberockhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7514079714639732909&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kobe-japanese-steakhouse-of-rock-hill",
      "poi_latitude": "34.9745383",
      "poi_longitude": "-81.0241538",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZpS_HKPVogRreARbbBfR2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a5da67d8-95c1-499d-8de8-dfa2bb17beb7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Eggs Up Grill",
      "poi_type": "Restaurants",
      "poi_address": "2732 Celanese Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Relaxed chain serving a menu of breakfast, burgers & sandwiches in a colorful setting.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious breakfast and lunch, featuring favorites like biscuits and gravy, shrimp and grits, and gluten-free pancakes, all served in generous portions. The friendly staff, clean and inviting atmosphere, and reasonable prices further enhance the dining experience.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-6ef1-724d-8397-e6cdb3c496e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-6ef1-724d-8397-e6cdb3c496e0",
        "storage_key": "property/6767906449164261/019ff7af-6ef1-724d-8397-e6cdb3c496e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.eggsupgrill.com/sc/rock-hill/23/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6386773140130093541&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eggs-up-grill",
      "poi_latitude": "34.977382",
      "poi_longitude": "-81.02699489999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-327-3447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP46z4SuPVogR5dl1FlVgolg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0e4c7dab-09d2-4b38-8ffd-6a34b7516e86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2415 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves fresh chicken strips and fries. They also highlight the friendly staff and the manager's willingness to resolve issues.\n\nSome reviews mention the wait can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-757f-71bc-8021-b24bbcde0f8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-757f-71bc-8021-b24bbcde0f8b",
        "storage_key": "property/6767906449164261/019ff7af-757f-71bc-8021-b24bbcde0f8b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/sc/cherry-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13462956603777026345&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "34.9692872",
      "poi_longitude": "-80.99371819999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-325-1323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65lbT1OPVogRKQmhirMH1ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1ecac4c2-0b10-4878-81d1-840156556c0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2367 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Diners like this restaurant's delicious steaks, especially the flavorful ribeye, and the freshly baked rolls with cinnamon honey butter. They also highlight the attentive and friendly staff, as well as the lively atmosphere.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd5-504d-775d-af93-5fa08eaefb0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd5-504d-775d-af93-5fa08eaefb0b",
        "storage_key": "property/6767906449164261/019e1dd5-504d-775d-af93-5fa08eaefb0b.webp",
        "width": 1079,
        "height": 555
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/south-carolina/rock-hill?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=6133918735119437275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "34.94186",
      "poi_longitude": "-80.9625484",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-909-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VIto0GGVogR203oN5cOIFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_52620c59-0a4f-46cb-91fa-fce27db7002f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "630 Tinsley Way, Rock Hill, SC 29730, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Diners enjoy this restaurant's delicious and well-prepared food, including hearty ribs, and appreciate the fast and friendly service from the staff.\n\nOther reviews mention the food can be inconsistent and the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-7265-766f-886e-e804fb552d78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-7265-766f-886e-e804fb552d78",
        "storage_key": "property/6767906449164261/019ff7af-7265-766f-886e-e804fb552d78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations/us/south-carolina/rock-hill/rock-hill?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=17405524138356561530&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "34.942576",
      "poi_longitude": "-80.974942",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-980-8334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlygMJj2GVogRetY6RPzXjPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c119b35c-805f-4341-8b89-e4bd7a192da2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "FUJI JAPAN Japanese Steakhouse and Hibachi Grill",
      "poi_type": "Restaurants",
      "poi_address": "2455 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Easygoing Japanese steakhouse serving hibachi dishes alongside a sushi bar with rolls & sashimi.",
      "poi_long_description": "Diners like this Japanese restaurant's delicious hibachi and fresh sushi, with many highlighting the generous portions and flavorful dishes like sweet carrots and crab rangoons. They also mention the entertaining hibachi show, friendly staff, and accommodating service for special occasions.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-71a8-71a7-8502-535d84108b80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-71a8-71a7-8502-535d84108b80",
        "storage_key": "property/6767906449164261/019ff7af-71a8-71a7-8502-535d84108b80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fujirockhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1012880173054107557&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fuji-japan-japanese-steakhouse-and-hibachi-grill",
      "poi_latitude": "34.97032799999999",
      "poi_longitude": "-80.992685",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-327-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQR3fVOPVogRpR_toiZ5Dg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_3e51f863-734d-45b2-a7d8-f595e12865f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill Riverwalk",
      "poi_type": "Entertainment",
      "poi_address": "Piedmont Medical Center Trail, Rock Hill, SC 29730, USA",
      "poi_short_description": "Scenic path along the Catawba River with benches offering kayaking and cycling.",
      "poi_long_description": "People say this riverwalk offers a beautiful, paved trail perfect for walking, biking, and dog walking, with scenic views of the Catawba River. Visitors also highlight the presence of benches, swings, and historical plaques along the trail, as well as convenient restrooms. They also like the peaceful ambiance and the proximity to restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-772e-7499-b48a-e4e2d4c71fc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-772e-7499-b48a-e4e2d4c71fc5",
        "storage_key": "property/6767906449164261/019ff7af-772e-7499-b48a-e4e2d4c71fc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13289256595559931673&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-riverwalk",
      "poi_latitude": "34.9837739",
      "poi_longitude": "-80.9719738",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2109-725f-8bdf-c2f27bddf2d2",
        "storage_key": "property/6767906449164261/019e1dd9-2109-725f-8bdf-c2f27bddf2d2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8BUN-yFVogRGd9d03bsbLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a8be9eb2-1a04-4f05-a113-8e6d4d913361",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill Outdoor Center",
      "poi_type": "Entertainment",
      "poi_address": "1307 Riverwalk Parkway, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-764b-73c9-8e56-2a3ebab0783b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-764b-73c9-8e56-2a3ebab0783b",
        "storage_key": "property/6767906449164261/019ff7af-764b-73c9-8e56-2a3ebab0783b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=392228278349307646&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-outdoor-center",
      "poi_latitude": "34.9737745",
      "poi_longitude": "-80.9662433",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1wnlW-GVogR_p7fgYp5cQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_d4929241-98de-47bd-a46a-8b8f1374678d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill Sports & Event Center",
      "poi_type": "Entertainment",
      "poi_address": "326 Technology Center Way, Rock Hill, SC 29730, USA",
      "poi_short_description": "Modern sports facility hosting basketball and volleyball events plus tournaments and concerts, along with clean restrooms.",
      "poi_long_description": "People say this sports and events center is a beautiful, clean, and well-maintained facility with modern courts and equipment for various sports. They also highlight the convenient and ample parking, as well as the availability of food and snacks. Guests mention the friendly and helpful staff, and appreciate the overall great atmosphere for tournaments and events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-7b60-724c-8618-008f3da90b8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-7b60-724c-8618-008f3da90b8e",
        "storage_key": "property/6767906449164261/019ff7af-7b60-724c-8618-008f3da90b8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/84/8145",
      "poi_directions_map_url": "https://maps.google.com/?cid=5724994505651102456&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-sports--event-center",
      "poi_latitude": "34.932384",
      "poi_longitude": "-81.0300768",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-5675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4VmJhbaJVogR-KJlqitEc08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_791649fd-7dc4-4453-a5f6-1bc3d25d0f0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Stars and Strikes",
      "poi_type": "Entertainment",
      "poi_address": "2225 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Family fun center with bowling, laser tag, an arcade, axe throwing, and an American-style restaurant.",
      "poi_long_description": "People say this entertainment center offers a wide variety of activities, including bowling, laser tag, and arcade games, with many options for all ages. They also highlight the good food and drinks, as well as the clean and well-maintained facilities. Guests mention the friendly and helpful staff, who contribute to a fun and engaging atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-7b10-743c-b25f-c2f61da1a329.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-7b10-743c-b25f-c2f61da1a329",
        "storage_key": "property/6767906449164261/019ff7af-7b10-743c-b25f-c2f61da1a329.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://starsandstrikes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3945030769914324840&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stars-and-strikes",
      "poi_latitude": "34.9434755",
      "poi_longitude": "-80.96690219999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 678-965-5707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-UZzfGHVogRaKe6ZJWQvzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_2aeaec54-db13-4dd3-9c84-69aff454df0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Strikers Family SportsCenter",
      "poi_type": "Entertainment",
      "poi_address": "124 N Anderson Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Bowling alley, pool hall and game center with a snack bar, a beer selection and friendly service.",
      "poi_long_description": "People say this bowling alley offers well-maintained lanes, a pro shop, and additional amenities like pool tables and arcade games. Guests also highlight the friendly and helpful staff, reasonable prices, and a fun, family-friendly atmosphere.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-7851-70e4-bd11-6a91361c0377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-7851-70e4-bd11-6a91361c0377",
        "storage_key": "property/6767906449164261/019ff7af-7851-70e4-bd11-6a91361c0377.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.strikerssc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1176432480853423038&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "strikers-family-sportscenter",
      "poi_latitude": "34.9416606",
      "poi_longitude": "-80.99659679999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-5210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqW1GDZqIVogRvvN_uxuHUxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_b4aa7411-8592-4ea2-8ee6-c262db2ef59d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Off The Tracks Brewing",
      "poi_type": "Entertainment",
      "poi_address": "502 Cherry Rd #106, Rock Hill, SC 29730, USA",
      "poi_short_description": "Laid-back craft brewery serving a brick-oven-style pizza menu along with a patio and friendly staff.",
      "poi_long_description": "People say this brewery offers delicious pizza, wings, and a variety of decent beer options. They also highlight the great atmosphere and kind staff.\n\nSome reviews mention the food can be poorly prepared.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-7b14-7091-acbe-067552281b41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-7b14-7091-acbe-067552281b41",
        "storage_key": "property/6767906449164261/019ff7af-7b14-7091-acbe-067552281b41.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://offthetracksbrewing.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=16695216021553850118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "off-the-tracks-brewing",
      "poi_latitude": "34.9430724",
      "poi_longitude": "-81.0305734",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-326-6882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1be0-768b-967e-3245e6849cbe",
        "storage_key": "property/6767906449164261/019e1dd9-1be0-768b-967e-3245e6849cbe.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9SqEGOJVogRBqcgPYRSsec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_0f971f94-1b1f-4689-8475-f87069fe36bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Visitors say this amusement park offers a great mix of thrilling rides, including Fury 325 and Copperhead Strike, and has plenty of attractions for all ages, like Camp Snoopy and a water park. They also highlight the friendly staff, clean grounds, and the value of season passes for frequent visits.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-808d-77dc-b776-efc9755d3d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-808d-77dc-b776-efc9755d3d82",
        "storage_key": "property/6767906449164261/019ff7af-808d-77dc-b776-efc9755d3d82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_41b17bb2-956b-4693-9fd3-364cda3df541",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Riverwalk YMCA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "998 Riverwalk Parkway, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7af-7dbe-75af-8d98-cd6bba54903c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7af-7dbe-75af-8d98-cd6bba54903c",
        "storage_key": "property/6767906449164261/019ff7af-7dbe-75af-8d98-cd6bba54903c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaup.org/branch/riverwalk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2418509875005368602&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwalk-ymca",
      "poi_latitude": "34.9770361",
      "poi_longitude": "-80.97770249999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-328-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZjElvqFVogRGil44epFkCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_f51000c1-d7e0-4f47-a3e3-ca25c17afbb1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "ISI Elite Training - Rock Hill, SC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1738 Celanese Rd Ste 103, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-f764-70fb-8e41-c2da7e7598f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7b6-f764-70fb-8e41-c2da7e7598f1",
        "storage_key": "property/6767906449164261/019ff7b6-f764-70fb-8e41-c2da7e7598f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.isielitetraining.com/isi-location/rock-hill",
      "poi_directions_map_url": "https://maps.google.com/?cid=13257538944770045089&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "isi-elite-training---rock-hill-sc",
      "poi_latitude": "34.9767921",
      "poi_longitude": "-81.0019126",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-4786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ10wkWmPVogRofTsxm09_Lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_68423d27-b632-46ca-9f64-fcefa5a5ca6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Atrium Health Primary Care Shiland Family Medicine",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1656 Riverchase Blvd #2400, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-f847-756a-9102-be3eefc8c948.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7b6-f847-756a-9102-be3eefc8c948",
        "storage_key": "property/6767906449164261/019ff7b6-f847-756a-9102-be3eefc8c948.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-primary-care-shiland-family-medicine-rock-hill?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=10476028493378896870&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "atrium-health-primary-care-shiland-family-medicine",
      "poi_latitude": "34.9801025",
      "poi_longitude": "-80.98928719999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-5131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1bdf-7755-a482-ebd0eacd7916",
        "storage_key": "property/6767906449164261/019e1dd9-1bdf-7755-a482-ebd0eacd7916.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yH-KCyPVogR5kO4DGlUYpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_51cb7bfa-82f1-45a9-a42f-f07baa009191",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Rock Hill Hospital - Piedmont Medical Network",
      "poi_type": "Major Employers & Offices",
      "poi_address": "222 S Herlong Ave, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd6-b8de-77e7-889d-88cb71c1e6ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd6-b8de-77e7-889d-88cb71c1e6ce",
        "storage_key": "property/6767906449164261/019e1dd6-b8de-77e7-889d-88cb71c1e6ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmontmedicalnetwork.com/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-piedmontmc-rockhill&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4319733036252752549&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-hospital---piedmont-medical-network",
      "poi_latitude": "34.956872",
      "poi_longitude": "-81.0507432",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-2100-749d-b6f7-bc56b90d3af5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2100-749d-b6f7-bc56b90d3af5",
        "storage_key": "property/6767906449164261/019e1dd9-2100-749d-b6f7-bc56b90d3af5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRei2DiJVogRpWpdPk_G8js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_3ddea65f-3521-4446-bc5a-0b7296719ffa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "York Technical College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "452 Anderson Rd S, Rock Hill, SC 29730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-f7eb-7708-acd5-7214ec589505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7b6-f7eb-7708-acd5-7214ec589505",
        "storage_key": "property/6767906449164261/019ff7b6-f7eb-7708-acd5-7214ec589505.webp",
        "width": 1280,
        "height": 885
      },
      "poi_business_url": "http://www.yorktech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7635310615410994742&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "york-technical-college",
      "poi_latitude": "34.935098",
      "poi_longitude": "-80.995289",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-327-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEbhMOoWIVogRNm5XFY0S9mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_24cc81dd-125a-495c-bf26-586921c3ed4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "Clinton College (HBCU)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1029 Crawford Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-f4a1-75be-b595-c6f31cb94492.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7b6-f4a1-75be-b595-c6f31cb94492",
        "storage_key": "property/6767906449164261/019ff7b6-f4a1-75be-b595-c6f31cb94492.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.clintoncollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13982178984062290010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clinton-college-hbcu",
      "poi_latitude": "34.9134144",
      "poi_longitude": "-81.0429245",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-327-7402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-1c52-71f9-99fc-26665961d540",
        "storage_key": "property/6767906449164261/019e1dd9-1c52-71f9-99fc-26665961d540.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVfwtYLqJVogRWgj3irStCsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fddafe1b-eb25-4c4c-8759-ed18066f8b2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "York County Library",
      "poi_type": "Major Employers & Offices",
      "poi_address": "138 E Black St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Library with a kids section and free genealogy sessions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-f50e-76ce-98bc-95ad0ea06fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7b6-f50e-76ce-98bc-95ad0ea06fd1",
        "storage_key": "property/6767906449164261/019ff7b6-f50e-76ce-98bc-95ad0ea06fd1.webp",
        "width": 1076,
        "height": 768
      },
      "poi_business_url": "https://www.yclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17228081395597723792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "york-county-library",
      "poi_latitude": "34.9248181",
      "poi_longitude": "-81.0282599",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-981-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-ffb3-722d-bcaa-ac793b5aeaff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff7b6-ffb3-722d-bcaa-ac793b5aeaff",
        "storage_key": "property/6767906449164261/019ff7b6-ffb3-722d-bcaa-ac793b5aeaff.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJ48aesVWIVogRkEgeQsBwFu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_5420c210-2086-48de-b479-fb5f8f5df5a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2191 Ebenezer Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "U.S. Postal Service branch for mail and package delivery services, money orders, and other shipping and logistics tasks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-f478-762a-aa2d-0fd6925393e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff7b6-f478-762a-aa2d-0fd6925393e4",
        "storage_key": "property/6767906449164261/019ff7b6-f478-762a-aa2d-0fd6925393e4.webp",
        "width": 720,
        "height": 730
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1361996?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=10358156536144321948&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "34.96847169999999",
      "poi_longitude": "-81.0537265",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019ff7b6-ffb3-722d-bcaa-b01171e1999e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff7b6-ffb3-722d-bcaa-b01171e1999e",
        "storage_key": "property/6767906449164261/019ff7b6-ffb3-722d-bcaa-b01171e1999e.webp",
        "width": 192,
        "height": 157
      },
      "poi_google_place_id": "ChIJJ40ljDWJVogRnN3FYH2Qv48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_4e2a3581-7d69-4b33-b661-5b336d8fa054",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2aff93b4-420e-4418-a1d0-a8e795b58757",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_251a189e-59d7-475f-ad34-0a0f11734d72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b44f7f80-c442-41e8-b508-6ef5675f9e29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c332db16-ae37-4fa8-a6dd-3978f5e9082f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_9aaf4e7e-0591-483f-8fd6-f36d66e7e3ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_4c972d66-9b95-4b11-8b6e-550eccb3e43a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "rating": "5",
      "name": "Jonquease Walker",
      "text": "Marvin, head of maintenance made sure the job was done when the job was needed done high great appreciation.",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_34c3e164-ec59-4edb-ab52-33922c81b87e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "rating": "5",
      "name": "Shakeshia Pickett",
      "text": "Just really appreciate Marvin that works with maintenance he always gets my home back in tip top shape ! He make sure that all things are going well before exiting the home . His response times are great and he is my #1 go to guy to get the job done! Very trustworthy and always has the best attitude! Keep up the great job Marvin its greatly appreciated!",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_2cb72169-0046-4409-8a77-c6d541249e9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "rating": "5",
      "name": "Macy Fields",
      "text": "I wanted to take the time to speak on the 2 nicest maintenance workers I’ve ever met the first is Mr. Marvin whether I’m sweeping my porch or walking to the mail box he also has a kind word and if I see him and need anything it’s NEVER a problem he’s a kind man and that’s rare theses days\nThe second is Mr. Derek he is always ready to fix anything in the units and most importantly he always has an encouraging word for my teenager. I really appreciate theses two. Our community is blessed to have them both.",
      "date": "2026-03-13",
      "title": "false"
    },
    {
      "id": "custom_c63122e2-3b14-4b38-a8b0-57a444014fbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "rating": "5",
      "name": "Alexa Small",
      "text": "We’ve lived here a few years through multiple management companies. I’ve yet to meet the new office staff but wanted to leave a review purely for Marvin from the maintenance team. Our power went out in the middle of this snowstorm and when the power company said it wasn’t an outage and to call our emergency maintenance line, Marvin was out here in 5 minutes getting to work on it. He walked to our building in the snow and spent two hours outside troubleshooting and fixing the issue to make sure we weren’t left without heat overnight since it’s supposed to get down to 12 degrees. He’s an awesome guy, super polite, and genuinely cared about making sure we were good before he left. ⭐️⭐️⭐️⭐️⭐️ for Marvin specifically!",
      "date": "2026-01-30",
      "title": "false"
    },
    {
      "id": "custom_0c4392cb-777f-4faf-99a3-d33f961aba05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "rating": "5",
      "name": "Joyce Minto",
      "text": "Marvin service was excellent ,very Harding working 💪 exceptional work 👏",
      "date": "2026-01-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e3a008ae-3849-4e43-a5b1-a5d67df52dbf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019e1dd4-c2a5-74f7-ba6c-a25b1a25f572.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd4-c2a5-74f7-ba6c-a25b1a25f572",
        "storage_key": "property/6767906449164261/019e1dd4-c2a5-74f7-ba6c-a25b1a25f572.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "B2 Floorplan 2BR 2BTH",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4959"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-e587-725f-901e-3aadf843bba9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "historical---paces-river-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261"
    },
    {
      "lead_collector_id": "0198aa47-e5ec-7618-b5d9-2b786110f8f3",
      "lead_source": "FACEBOOK_ADS",
      "name": "historical---paces-river-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261"
    },
    {
      "lead_collector_id": "0198aa47-e651-7297-8789-24ec75b222a5",
      "lead_source": "LANDING_PAGE",
      "name": "historical---paces-river-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "apartments-with-pool-rock-hill-sc",
      "search_query": "apartments with pool Rock Hill SC",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Rock Hill, SC",
      "h2_subtitle": "Discover top-notch apartments with an inviting pool in Rock Hill, SC. Dive into comfort with us at The Summit at Rock Hill.",
      "page_copy": "At The Summit at Rock Hill, experience the bliss of living in a community with exquisite features, including an expansive and inviting pool right here in Rock Hill, SC. Whether you're looking to relax by the water or take a refreshing swim, our pool area offers the perfect setting for unwinding after a busy day or during a leisure weekend.\n\nOur community combines convenience with luxury. In addition to our unrivaled pool, residents benefit from a comprehensive range of amenities such as a modern fitness center, numerous planned social activities, and reliable package services. Situated in the heart of Rock Hill, The Summit offers easy access to local dining and shopping spots, creating the ideal environment for vibrant living. Enjoy the very best of what Rock Hill has to offer right at The Summit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Rock Hill, SC",
      "seo_description": "Explore apartments with a pool in Rock Hill, SC. Enjoy premium amenities and a vibrant lifestyle at The Summit at Rock Hill.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-rock-hill",
      "search_query": "dishwasher-equipped apartments Rock Hill",
      "category": "Amenity",
      "h1_title": "Dishwasher-Equipped Apartments in Rock Hill",
      "h2_subtitle": "Find your ideal dishwasher-equipped apartment in Rock Hill. Enjoy convenience and modern living at The Summit at Rock Hill.",
      "page_copy": "Welcome to The Summit at Rock Hill, where convenience meets modern living. Our apartments are thoughtfully designed with contemporary features, allowing you to enjoy the ease of dishwasher-equipped units in Rock Hill. No more hand-washing dishes after a long day—embrace the convenience of contemporary living with us.\n\nBeyond the kitchen, our community shines with a variety of amenities including a state-of-the-art fitness center and a stunning swimming pool. Located in charming Rock Hill, our residents benefit from quick access to the area's best dining and shopping experiences. Surrounded by an inviting community atmosphere, The Summit at Rock Hill is more than just a home; it's a lifestyle of comfort and ease.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher-Equipped Apartments in Rock Hill",
      "seo_description": "Discover dishwasher-equipped apartments in Rock Hill. Enjoy modern living at The Summit, featuring top amenities and vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "walk-in-closet-apartments-york-county",
      "search_query": "walk-in closet apartments in York County",
      "category": "Amenity",
      "h1_title": "Walk-In Closet Apartments in York County",
      "h2_subtitle": "Discover spacious apartments with walk-in closets in York County. Experience the lifestyle at The Summit at Rock Hill today.",
      "page_copy": "Explore spacious living at The Summit at Rock Hill, where our apartments feature impressive walk-in closets for all your storage needs. Located in the heart of York County, our community provides a blend of comfort and modern conveniences that enhance your living experience. \n\nOur spacious floor plans are complemented by a range of amenities, including a modern fitness center and a sparkling pool, ensuring you have the best of both comfort and luxury. Experience the difference of living in a community that values style and functionality, right in the vibrant atmosphere of York County. Join us at The Summit at Rock Hill and redefine your idea of the ideal living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walk-In Closet Apartments in York County",
      "seo_description": "Find apartments with walk-in closets in York County at The Summit. Enjoy comfort and modern amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "fitness-center-amenities-near-29732",
      "search_query": "fitness center amenities near 29732",
      "category": "Amenity",
      "h1_title": "Fitness Center Amenities Near 29732",
      "h2_subtitle": "Explore premier fitness center amenities near the 29732 area. Elevate your lifestyle at The Summit at Rock Hill.",
      "page_copy": "Experience a superior lifestyle at The Summit at Rock Hill, offering exceptional fitness center amenities conveniently located near the 29732 area. Our state-of-the-art fitness center is designed to accommodate various workout routines, ensuring our residents have everything they need to maintain a healthy and active lifestyle.\n\nBeyond the fitness center, The Summit offers a multitude of amenities, such as a stunning pool and engaging social activities, perfect for those who enjoy an active community life. Nestled in Rock Hill, SC, our location provides easy access to local shops and dining, making it an ideal setting for anyone seeking balance and convenience. Discover the vibrant lifestyle awaiting you at The Summit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Amenities Near 29732",
      "seo_description": "Discover top-notch fitness center amenities near 29732 at The Summit. Enjoy a vibrant lifestyle with modern features and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-rock-hill-sc",
      "search_query": "pet-friendly apartments Rock Hill SC",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Rock Hill, SC",
      "h2_subtitle": "Discover pet-friendly apartments in Rock Hill, SC. Enjoy the perfect place for you and your furry friends at The Summit at Rock Hill.",
      "page_copy": "Welcome to The Summit at Rock Hill, where pet-friendly living is a celebrated part of our community. Our apartments in Rock Hill, SC offer a warm environment for both you and your furry companions, ensuring that everyone feels right at home.\n\nIn addition to welcoming pets, our community boasts a range of amenities such as a modern fitness center and a beautiful swimming pool, providing a perfect blend of fun and relaxation. Located in the heart of Rock Hill, our residents enjoy easy access to nearby parks and outdoor areas, ideal for daily walks and playtime with pets. Join us at The Summit and experience a lifestyle tailored for you and your entire family.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Rock Hill, SC",
      "seo_description": "Explore pet-friendly apartments in Rock Hill, SC at The Summit. Enjoy a welcoming community with modern amenities and spaces for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-rock-hill-sc",
      "search_query": "one bedroom apartments rock hill sc",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Rock Hill, SC",
      "h2_subtitle": "Discover stylish one bedroom apartments in Rock Hill, SC's vibrant community. Find your ideal home at The Summit at Rock Hill.",
      "page_copy": "Welcome to The Summit at Rock Hill, where our one bedroom apartments offer the perfect blend of comfort and style within Rock Hill, SC. Designed with thoughtful layouts, each apartment provides a cozy yet spacious living space ideal for singles or couples looking for their next home.\n\nLocated in the heart of Rock Hill, our community gives residents access to a wealth of amenities including a modern fitness center and a sparkling pool. Enjoy the convenience of nearby shopping and dining options, plus our planned social activities that make building new connections easy. Experience the best of Rock Hill living at The Summit, where convenience meets quality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Rock Hill, SC",
      "seo_description": "Find stylish one bedroom apartments in Rock Hill, SC at The Summit. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-york-county",
      "search_query": "two bedroom apartments york county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in York County",
      "h2_subtitle": "Explore spacious two bedroom apartments in York County. Experience enhanced living at The Summit at Rock Hill.",
      "page_copy": "Welcome to The Summit at Rock Hill, where our two bedroom apartments provide a spacious and inviting atmosphere in York County. Perfect for families or roommates, these apartments are thoughtfully designed to offer ample space and comfort.\n\nSituated in Rock Hill, SC, our community is equipped with modern amenities like a well-equipped fitness center and a stunning pool area. Enjoy a vibrant neighborhood with convenient access to local attractions, shopping, and dining, making it easy to enjoy everything York County has to offer. Discover a home that caters to your lifestyle at The Summit, where your living experience is our priority.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in York County",
      "seo_description": "Discover spacious two bedroom apartments in York County at The Summit. Enjoy modern amenities and a community-focused lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164261",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-29732",
      "search_query": "three bedroom apartments near 29732",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 29732",
      "h2_subtitle": "Find spacious three bedroom apartments near 29732. Experience comfort and convenience at The Summit at Rock Hill.",
      "page_copy": "Discover the ideal family home with our three bedroom apartments at The Summit at Rock Hill, located conveniently near 29732. These expansive apartments offer the perfect solution for larger households or individuals seeking extra space.\n\nNestled in a vibrant community, our Rock Hill location provides not only a comfortable living environment but also easy access to local schools, parks, and dining options. Residents enjoy an array of amenities, including a modern fitness center and a refreshing pool. Come home to The Summit at Rock Hill, where your spacious and comfortable living experience awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
      "featured_image_media": {
        "alt_text": "Bright blue swimming pool with lounge chairs and tables, adjacent to a building with large windows.",
        "public_id": "019d0811-e977-76ac-9e4d-07a7d20c57a9",
        "storage_key": "property/6767906449164261/019d0811-e977-76ac-9e4d-07a7d20c57a9.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 29732",
      "seo_description": "Explore three bedroom apartments near 29732 at The Summit. Enjoy spacious living with modern amenities in a convenient Rock Hill location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4494"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "8013140183"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5479333"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_l_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=l"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_y_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=y"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KMFP3XTP"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_af_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=af"
    },
    {
      "ID": "custom_knock_ag_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=ag"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_br_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=br"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_db_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=db"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_l_title",
      "type": "STRING",
      "value": "Locator"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_rp_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=rp"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_y_title",
      "type": "STRING",
      "value": "Yelp"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_zu_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=zu"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "803-903-5637"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_af_title",
      "type": "STRING",
      "value": "Apartment Finder"
    },
    {
      "ID": "custom_knock_ag_title",
      "type": "STRING",
      "value": "Apartment Guide"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_br_title",
      "type": "STRING",
      "value": "Brochure/Flyer"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_db_title",
      "type": "STRING",
      "value": "Drive-by"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "803-913-9581"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_l_number",
      "type": "STRING",
      "value": "803-882-3344"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "803-281-3846"
    },
    {
      "ID": "custom_knock_rp_title",
      "type": "STRING",
      "value": "RentPath"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "803-471-4372"
    },
    {
      "ID": "custom_knock_y_number",
      "type": "STRING",
      "value": "803-916-2991"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "803-770-5146"
    },
    {
      "ID": "custom_knock_zu_title",
      "type": "STRING",
      "value": "Zumper"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_af_number",
      "type": "STRING",
      "value": "803-656-1215"
    },
    {
      "ID": "custom_knock_ag_number",
      "type": "STRING",
      "value": "803-373-1948"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "803-971-4482"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "803-303-0439"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_br_number",
      "type": "STRING",
      "value": "803-721-4892"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "803-268-3471"
    },
    {
      "ID": "custom_knock_db_number",
      "type": "STRING",
      "value": "803-913-9529"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "803-839-0837"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "803-598-1047"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "803-866-5923"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_rp_number",
      "type": "STRING",
      "value": "803-676-7925"
    },
    {
      "ID": "custom_knock_zu_number",
      "type": "STRING",
      "value": "803-902-4725"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "803-615-2524"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "803-353-1796"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "803-962-8710"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "803-653-6539"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "803-913-5101"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "803-902-3755"
    },
    {
      "ID": "custom_knock_refcr_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=refcr"
    },
    {
      "ID": "custom_knock_reffr_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=reffr"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "803-850-4308"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_costar_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=costar"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "803-759-8886"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_refcr_title",
      "type": "STRING",
      "value": "Referral - Current Resident"
    },
    {
      "ID": "custom_knock_reffr_title",
      "type": "STRING",
      "value": "Referral - Former Resident"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "26794657830"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "803-258-6829"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "803-918-6847"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e711f0f61c7baa29"
    },
    {
      "ID": "custom_knock_costar_title",
      "type": "STRING",
      "value": "CoStar"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "803-887-2968"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_refcr_number",
      "type": "STRING",
      "value": "803-594-4578"
    },
    {
      "ID": "custom_knock_reffr_number",
      "type": "STRING",
      "value": "803-921-0756"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "803-891-7004"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_costar_number",
      "type": "STRING",
      "value": "803-884-2570"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "803-715-1828"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "803-618-4218"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "803-615-2135"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "803-962-8566"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "803-921-8399"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "803-879-4986"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.thesummitatrockhill.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "803-921-8815"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "803-866-5923"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "4494",
  "custom_repli_id": "8013140183",
  "custom_realpage_id": "5479333",
  "custom_knock_a_link": "https://www.thesummitatrockhill.com?utm_knock=a",
  "custom_knock_g_link": "https://www.thesummitatrockhill.com?utm_knock=g",
  "custom_knock_l_link": "https://www.thesummitatrockhill.com?utm_knock=l",
  "custom_knock_r_link": "https://www.thesummitatrockhill.com?utm_knock=r",
  "custom_knock_w_link": "https://www.thesummitatrockhill.com?utm_knock=w",
  "custom_knock_y_link": "https://www.thesummitatrockhill.com?utm_knock=y",
  "custom_knock_z_link": "https://www.thesummitatrockhill.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-KMFP3XTP",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_af_link": "https://www.thesummitatrockhill.com?utm_knock=af",
  "custom_knock_ag_link": "https://www.thesummitatrockhill.com?utm_knock=ag",
  "custom_knock_al_link": "https://www.thesummitatrockhill.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.thesummitatrockhill.com?utm_knock=ar",
  "custom_knock_br_link": "https://www.thesummitatrockhill.com?utm_knock=br",
  "custom_knock_cl_link": "https://www.thesummitatrockhill.com?utm_knock=cl",
  "custom_knock_db_link": "https://www.thesummitatrockhill.com?utm_knock=db",
  "custom_knock_fb_link": "https://www.thesummitatrockhill.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.thesummitatrockhill.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.thesummitatrockhill.com?utm_knock=gp",
  "custom_knock_l_title": "Locator",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_rp_link": "https://www.thesummitatrockhill.com?utm_knock=rp",
  "custom_knock_w_title": "Property Website",
  "custom_knock_y_title": "Yelp",
  "custom_knock_z_title": "Zillow",
  "custom_knock_zu_link": "https://www.thesummitatrockhill.com?utm_knock=zu",
  "custom_knock_a_number": "803-903-5637",
  "custom_knock_ads_link": "https://www.thesummitatrockhill.com?utm_knock=ads",
  "custom_knock_af_title": "Apartment Finder",
  "custom_knock_ag_title": "Apartment Guide",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.thesummitatrockhill.com?utm_knock=bnr",
  "custom_knock_br_title": "Brochure/Flyer",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_db_title": "Drive-by",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "803-913-9581",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_l_number": "803-882-3344",
  "custom_knock_lcs_link": "https://www.thesummitatrockhill.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.thesummitatrockhill.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.thesummitatrockhill.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.thesummitatrockhill.com?utm_knock=psa",
  "custom_knock_r_number": "803-281-3846",
  "custom_knock_rp_title": "RentPath",
  "custom_knock_w_number": "803-471-4372",
  "custom_knock_y_number": "803-916-2991",
  "custom_knock_z_number": "803-770-5146",
  "custom_knock_zu_title": "Zumper",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_af_number": "803-656-1215",
  "custom_knock_ag_number": "803-373-1948",
  "custom_knock_al_number": "803-971-4482",
  "custom_knock_amap_link": "https://www.thesummitatrockhill.com?utm_knock=amap",
  "custom_knock_ar_number": "803-303-0439",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_br_number": "803-721-4892",
  "custom_knock_cl_number": "803-268-3471",
  "custom_knock_db_number": "803-913-9529",
  "custom_knock_fb_number": "803-839-0837",
  "custom_knock_fl_number": "803-598-1047",
  "custom_knock_gp_number": "803-866-5923",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.thesummitatrockhill.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_rp_number": "803-676-7925",
  "custom_knock_zu_number": "803-902-4725",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "803-615-2524",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.thesummitatrockhill.com?utm_knock=bcard",
  "custom_knock_bnr_number": "803-353-1796",
  "custom_knock_cfres_link": "https://www.thesummitatrockhill.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "803-962-8710",
  "custom_knock_lgp_number": "803-653-6539",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.thesummitatrockhill.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "803-913-5101",
  "custom_knock_psa_number": "803-902-3755",
  "custom_knock_refcr_link": "https://www.thesummitatrockhill.com?utm_knock=refcr",
  "custom_knock_reffr_link": "https://www.thesummitatrockhill.com?utm_knock=reffr",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "803-850-4308",
  "custom_knock_bandit_link": "https://www.thesummitatrockhill.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_costar_link": "https://www.thesummitatrockhill.com?utm_knock=costar",
  "custom_knock_flyers_link": "https://www.thesummitatrockhill.com?utm_knock=flyers",
  "custom_knock_osoc_number": "803-759-8886",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_refcr_title": "Referral - Current Resident",
  "custom_knock_reffr_title": "Referral - Former Resident",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "26794657830",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "803-258-6829",
  "custom_knock_cfres_number": "803-918-6847",
  "custom_knock_chatgpt_link": "https://www.thesummitatrockhill.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "e711f0f61c7baa29",
  "custom_knock_costar_title": "CoStar",
  "custom_knock_dirmail_link": "https://www.thesummitatrockhill.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "803-887-2968",
  "custom_knock_propbro_link": "https://www.thesummitatrockhill.com?utm_knock=propbro",
  "custom_knock_refcr_number": "803-594-4578",
  "custom_knock_reffr_number": "803-921-0756",
  "custom_knock_bandit_number": "803-891-7004",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_costar_number": "803-884-2570",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "803-715-1828",
  "custom_knock_outbound_link": "https://www.thesummitatrockhill.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.thesummitatrockhill.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "803-618-4218",
  "custom_knock_dirmail_number": "803-615-2135",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "803-962-8566",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "803-921-8399",
  "custom_knock_revcards_number": "803-879-4986",
  "custom_knock_maintenance_link": "https://www.thesummitatrockhill.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "803-921-8815",
  "custom_ppc_tracking_phone_number": "803-866-5923",
  "custom_audioeye_site_id": "c89b1a54-9d06-4ff0-ba64-d8b03d017b4a",
  "custom_audioeye_site_hash": "a4e7bd1b2790791963c9dc111eecfa73"
};

export const generatedAt = '2026-10-28T16:32:57.941Z';
